// Data Explorer — the Power-BI-like tool (2026-10-22), in the portal's four languages.
// Field and dataset labels live here, keyed by the server's own keys (f_<field>, ds_<dataset>), so a dataset added
// later is labelled in one place.
const en = {
  // operations datasets — Samples, Project SKUs, Tickets (Max 31/10)
  ds_samples: "Samples",
  ds_skus: "Project SKUs",
  ds_tickets: "Tickets",
  group_status: "Status",
  group_people: "People",
  group_checks: "Missing information",
  sw_allRounds: "Every round (not only the current one)",
  f_request_date: "Request date",
  f_due_date: "Development Due",
  f_sent_date: "Sent date",
  f_state: "State",
  f_late_state: "On time / late",
  f_due_bucket: "Due when",
  f_rm_state: "Material (RM)",
  f_outcome: "Outcome",
  f_rework_reason: "Rework reason",
  f_round: "Round",
  f_developer: "Developer",
  f_designer: "Designer",
  f_location: "Made at",
  f_team: "Sales OP team",
  f_project: "Project",
  f_sample: "Sample",
  f_season: "Season",
  f_rounds: "Rounds",
  f_samples_count: "Samples",
  f_in_work: "In work",
  f_waiting_comment: "Waiting comment",
  f_overdue_not_sent: "Overdue, not sent",
  f_sent_late: "Sent late",
  f_sent_on_time: "Sent on time",
  f_days_late: "Days late",
  f_make_days: "Days to make",
  f_round_cycle_days: "Round cycle (days)",
  f_exf_date: "EXF date",
  f_created_date: "Created",
  f_status: "Status",
  f_sku_approval: "SKU approval",
  f_project_approval: "Project approval",
  f_exf_bucket: "EXF when",
  f_order_kind: "New / repeat order",
  f_has_remark: "Remark",
  f_chk_exf: "EXF date",
  f_chk_developer: "Developer",
  f_chk_designer: "Designer",
  f_chk_sales_rep: "Sales rep",
  f_chk_season: "Season",
  f_chk_launch: "Launch month",
  f_owner: "Project owner",
  f_sales_rep: "Sales rep",
  f_vendor: "Vendor",
  f_project_category: "Project category",
  f_launch_month: "Launch month",
  f_project_count: "Projects",
  f_skus_missing_info: "SKUs missing information",
  f_missing_fields: "Missing fields",
  f_closed_date: "Closed",
  f_team_reply: "Team reply",
  f_due_state: "Due state",
  f_ticket_code: "Ticket code",
  f_receiving_team: "Receiving team",
  f_assignee: "Assignee",
  f_requester: "Requester",
  f_ticket: "Ticket",
  f_ticket_count: "Tickets",
  f_open_tickets: "Open tickets",
  f_overdue_tickets: "Overdue tickets",
  f_days_to_close: "Days to close",
  f_days_open: "Days open",
  title: 'Data Explorer',
  asOf: 'Data to {{date}}',
  dataset: 'Dataset',
  ds_sales: 'Sales',
  ds_inventory: 'Inventory',
  ds_marketing: "Marketing",
  group_channel: "Channel",
  f_mkt_date: "Day",
  f_market: "Market",
  f_mkt_channel: "Channel type",
  f_mkt_platform: "Platform",
  f_mkt_account: "Account",
  f_campaign: "Campaign",
  f_mkt_currency: "Account currency",
  f_ad_spend: "Ad spend",
  f_impressions: "Impressions",
  f_ad_clicks: "Clicks",
  f_ctr: "CTR",
  f_cpc: "Cost per click",
  f_cpm: "Cost per 1,000 impressions",
  f_attributed_revenue: "Revenue the ads claim",
  f_attributed_orders: "Purchases the ads claim",
  f_roas: "ROAS (claimed)",
  f_email_revenue: "Email revenue (Klaviyo)",
  f_email_orders: "Email orders (Klaviyo)",
  f_sessions: "Web sessions (GA4)",
  f_web_revenue: "Web revenue (GA4)",
  f_web_orders: "Web orders (GA4)",
  f_web_conversion: "Web conversion rate",
  f_store_sales: "Store sales (Shopify)",
  f_store_orders: "Store orders (Shopify)",
  f_mer: "Store sales ÷ ad spend",
  f_spend_share: "Ad spend ÷ store sales",
  ds_pole_position: "Pole position",
  f_snap_date: "Snapshot day",
  f_base_month: "Closed month",
  f_line_kind: "Line kind",
  f_po_due: "Open PO due",
  f_pole_family: "Frame family",
  f_end_qty: "Stock end of closed month",
  f_received_qty: "Received since",
  f_to_group_qty: "To other entities since",
  f_sold_qty: "Sold since",
  f_other_qty: "Other movements",
  f_now_qty: "Stock today",
  f_po_total_qty: "Open PO (total)",
  f_po_qty: "Open PO qty",
  f_avg_month_sales: "Avg monthly sales (3 mo)",
  f_months_of_stock: "Months of stock",
  f_months_with_po: "Months of stock incl. open PO",
  group_stock: 'Stock',
  f_snapshot: 'Snapshot day',
  f_day_kind: 'Day kind (Friday = week)',
  f_latest_day: 'Latest day',
  f_ageing: 'Ageing',
  f_stock_kind: 'On hand / in transit',
  f_line_status: 'Line status',
  f_inbound_year: 'Inbound year',
  f_brand: 'Brand',
  f_goods_type: 'Goods type',
  f_inv_category: 'Category',
  f_inv_subcategory: 'Sub-category',
  f_family: 'Family',
  f_size_class: 'Size class',
  f_consignment: 'Own / consignment',
  f_product: 'Product',
  f_color: 'Colour',
  f_stock_amount: 'Amount on hand (USD)',
  f_stock_qty: 'Qty on hand',
  f_transit_amount: 'In transit amount (USD)',
  f_transit_qty: 'In transit qty',
  f_over1y_share: 'Over 1 year % of amount',
  f_avg_age: 'Average age (days)',
  sw_allDays: 'Every day taken',
  fieldSearch: 'Find a field…',
  group_time: 'Time',
  group_product: 'Product',
  group_org: 'Entity & channel',
  group_geo: 'Geography',
  group_measures: 'Values',
  f_date: 'Date',
  f_line: 'Line',
  f_category: 'Product category',
  f_type: 'Product type',
  f_subtype: 'Product subtype',
  f_frame_model: 'Frame model',
  f_frame_color: 'Frame colour',
  f_sku: 'SKU',
  f_entity_group: 'Entity group',
  f_entity: 'Entity',
  f_channel: 'Channel',
  f_channel2: 'Sub-channel',
  f_channel3: 'Channel detail',
  f_customer: 'Customer',
  f_region: 'Region',
  f_subregion: 'Subregion',
  f_country: 'Country',
  f_revenue: 'Revenue',
  f_quantity: 'Quantity',
  f_avg_price: 'Average unit price',
  f_sku_count: 'Number of SKUs',
  f_customer_count: 'Number of customers',
  f_lines: 'Transaction lines',
  f_target: 'Target',
  f_achievement: 'Achievement %',
  f_vs_target: 'vs target',
  vt_map: 'Map',
  w_location: 'Location',
  w_mapColor: 'Colour by',
  mapNeedsGeo: 'A map places a Country, a Subregion or a Region. Put one of them in Location.',
  mapNone: 'No value',
  mapUnplaced: 'Not on the map ({{n}}): {{names}}',
  fmtTopN: 'Show',
  fmtTopN_all: 'All rows',
  fmtTopN_n: 'Top {{n}}',
  topNote: 'Top {{n}} of {{total}} by the first value.',
  topNoteTable: 'Top {{n}} of {{total}} by the first value; the total row counts all of them.',
  targetBlocked: 'No target here: the target is set by date, entity group, entity and channel only, not by {{fields}}.',
  targetBlockedShort: 'No target by {{fields}}',
  relWholeN: 'complete only',
  relWholeOpt: 'To the end of the period (the target is the whole period\'s)',
  relWholeNOpt: 'Complete periods only (the current one left out)',
  relHintWhole: 'From the start of the period to its end. Sales stop at the latest day loaded; a target runs to the end, as the Sales Report sets a month to date against the whole month.',
  relHintNWhole: 'Whole periods before the current one: "Last 5 weeks" are the five weeks before this one, Monday to Sunday.',
  g_year: 'Year',
  g_quarter: 'Quarter',
  g_month: 'Month',
  g_week: 'Week',
  g_day: 'Day',
  a_sum: 'Sum',
  a_avg: 'Average',
  a_min: 'Min',
  a_max: 'Max',
  dropHere: 'Drag a field here',
  remove: 'Remove',
  sw_includeInternal: 'Internal-company sales',
  sw_includeOversea: 'Oversea sales',
  currency: 'Currency',
  chartTop: 'The chart shows the first {{n}} of {{total}} rows.',
  other: 'Other',
  total: 'Total',
  loading: 'Working…',
  truncated: 'Only the largest {{n}} groups are shown. Add a filter to see the rest.',
  tooManyCols: 'Showing the {{n}} largest of {{total}} columns. Filter the column field to choose others.',
  moreRows: 'Show {{n}} more rows',
  drillUp: 'Up one level',
  drillInto: 'Drill down into {{value}}',
  fInclude: 'Include',
  fExclude: 'Exclude',
  fContains: 'Contains',
  fSearch: 'Search values…',
  fSelectShown: 'Select shown',
  fClear: 'Clear',
  fApply: 'Apply',
  fCancel: 'Cancel',
  fMore: 'Only the first 500 are listed. Search to find others.',
  fNone: 'Nothing matches.',
  fFrom: 'From',
  fTo: 'To',
  fAll: 'All dates',
  fSelected: '{{n}} selected',
  containsText: 'Text the value contains',
  sumIn: '{{field}}: {{values}}',
  sumNotIn: '{{field}}: not {{values}}',
  sumMore: '+{{n}} more',
  sumContains: '{{field}} contains “{{text}}”',
  sumRange: '{{field}}: {{from}} – {{to}}',
  sumFrom: '{{field}}: from {{from}}',
  sumTo: '{{field}}: until {{to}}',
  sumAll: '{{field}}: all',
  save: 'Save',
  saveAs: 'Save as…',
  rename: 'Rename',
  share: "Share",
  delete: 'Delete',
  unsaved: 'Unsaved changes',
  saved: 'Saved',
  copyLink: 'Copy link',
  linkCopied: 'Link copied',
  by: 'by {{name}}',
  confirmDelete: 'Delete “{{name}}”? This cannot be undone.',
  sharedBadge: 'Shared',
  errLoad: 'Could not load the Data Explorer.',
  errNoDatasets: 'No dataset is open to you yet. Ask an admin for access.',
  reports: "Reports",
  myReports: "My reports",
  sharedReports: "Shared with me",
  noReports: "No saved reports yet.",
  newReport: "New report",
  untitled: "Untitled report",
  reportName: "Name of the report",
  editMode: "Edit",
  readMode: "Reading view",
  refresh: "Read the data again",
  clearSelection: "Clear the selection",
  emptyVisual: "Pick fields in the Data pane to build this visual.",
  emptyPage: "This page is empty. Pick a kind in the Visualizations pane, or tick a field in the Data pane.",
  emptyPageRead: "This page is empty.",
  tooManyVisuals: "A page holds at most {{n}} visuals.",
  drillMode: "Drill down: a click goes one level deeper",
  nextLevel: "Go to the next level",
  moreOptions: "More options",
  showTable: "Show as a table",
  showVisual: "Show the visual",
  focus: "Focus mode",
  backToReport: "Back to the report",
  exportData: "Export data (Excel)",
  duplicate: "Duplicate",
  removeVisual: "Remove",
  presets: "Quick range…",
  slicerAll: "All",
  dataPane: "Data",
  visPane: "Visualizations",
  filtersPane: "Filters",
  newVisual: "Add",
  visHint: "Pick a kind to add a visual, or click a visual on the page to change it.",
  vt_card: "Card",
  vt_table: "Table",
  vt_matrix: "Matrix",
  vt_column: "Column chart",
  vt_stacked: "Stacked column chart",
  vt_bar: "Bar chart",
  vt_line: "Line chart",
  vt_area: "Area chart",
  vt_slicer: "Slicer",
  w_fields: "Fields",
  w_columns: "Columns",
  w_rows: "Rows",
  w_cols: "Columns",
  w_values: "Values",
  w_xaxis: "X-axis",
  w_legend: "Legend",
  w_yaxis: "Y-axis",
  w_yaxisCat: "Y-axis",
  w_xaxisVal: "X-axis",
  w_field: "Field",
  vTitle: "Title",
  grain: "Date level",
  dateRange: "Date range",
  aggregation: "Aggregation",
  filtersVisual: "Filters on this visual",
  filtersPage: "Filters on this page",
  filtersAll: "Filters on all pages",
  addFilter: "Add a filter",
  pages: "Pages",
  pageN: "Page {{n}}",
  addPage: "New page",
  pageOptions: "Page options",
  pageTabHint: "Double-click to rename",
  renamePage: "Rename page",
  duplicatePage: "Duplicate page",
  moveLeft: "Move left",
  moveRight: "Move right",
  deletePage: "Delete page",
  confirmDeletePage: "Delete the page “{{name}}” and its visuals?",
  confirmNewDataset: "Another dataset starts a new report. The report on screen is lost unless you save it first. Go on?",
  titleBy: "{{values}} by {{dims}}",
  titleAnd: " and ",
  undo: "Undo (Ctrl+Z)",
  redo: "Redo (Ctrl+Y)",
  pageDeleted: "Page deleted — Undo puts it back.",
  allReports: "All reports",
  homeAll: "All",
  homeMine: "My reports",
  homeShared: "Shared with me",
  homeSearch: "Find a report…",
  colName: "Name",
  colOwner: "Owner",
  colSharedWith: "Shared with",
  colUpdated: "Last changed",
  you: "You",
  sharedWithYou: "Shared with you",
  sharedBy: "Shared by {{name}}",
  privateOnly: "Private",
  everyone: "Everyone",
  everyoneHint: "everybody who can see the {{ds}} data",
  nPeople: "{{n}} people",
  homeEmptyMine: "You have no report yet. Press New report to build one.",
  homeEmptyShared: "Nobody has shared a report with you yet.",
  homeEmptySearch: "No report matches.",
  continueDraft: "Continue where you left off",
  draftNew: "a new report not saved yet",
  draftChanged: "unsaved changes to “{{name}}”",
  continue: "Continue",
  discardDraft: "Discard",
  confirmDiscard: "Discard the unsaved changes to “{{name}}”?",
  shareTitle: "Share “{{name}}”",
  shareSearch: "Add people, departments or entities…",
  kind_all: "Everyone",
  kind_team: "Departments",
  kind_entity: "Entities",
  oneTeam: "Department",
  oneEntity: "Entity",
  kind_user: "People",
  sharePrivate: "Private — only you can open it.",
  shareReach: "{{n}} people will see it.",
  shareCannot: "{{n}} named here cannot see the {{ds}} data yet, so the report will not show for them until they can:",
  noAccessTag: "no access to the data",
  noAccessHint: "Has no permission for the {{ds}} data yet — will not see the report until given it.",
  shareNote: "They open it to read: filters and slicers change only their own screen. Only you change the report; anybody who builds reports can save a copy.",
  makePrivate: "Make private",
  shareSaved: "Sharing saved",
  shareSaveFirst: "Save the report first, then share it.",
  removeShare: "Remove",
  peopleWithAccess: "People with access",
  generalAccess: "General access",
  youMark: "(you)",
  roleOwner: "Owner",
  roleViewer: "Viewer",
  roleEditor: "Editor",
  roleHead: "Role",
  transferOwnership: "Transfer ownership",
  transferNoBuild: "{{name}} cannot build reports (no Data Explorer access), so they could not own it.",
  transferNoData: "{{name}} cannot see the {{ds}} data yet.",
  transferAsk: "Make {{name}} the owner?",
  transferHint: "You stay on as an editor. Only the new owner can share it, delete it or hand it on.",
  transferGo: "Transfer",
  transferDone: "{{name}} owns the report now — you stay on as an editor.",
  roleOf: "Access",
  removeAccess: "Remove access",
  genRestricted: "Restricted",
  genRestrictedHint: "Only the people added above can open it with the link",
  genEveryone: "Everyone who can see the {{ds}} data",
  genEveryoneHint: "Anybody at Helinox who can see the {{ds}} data can open it to read",
  copyLink: "Copy link",
  linkCopied: "Link copied",
  shareDone: "Done",
  noMatch: "Nothing matches.",
  notFound: "That report no longer exists, or is not shared with you.",
  deleted: "Report deleted",
  fBackwards: "The end date is before the start date.",
  nPerson: "1 person",
  shareReachOne: "1 person will see it.",
  rel_today: "Today",
  rel_yesterday: "Yesterday",
  rel_thisWeek: "This week",
  rel_lastWeek: "Last week",
  rel_thisMonth: "This month (to date)",
  rel_lastMonth: "Last month",
  rel_thisQuarter: "This quarter (to date)",
  rel_lastQuarter: "Last quarter",
  rel_thisYear: "This year (to date)",
  relW_thisWeek: "This week (whole)",
  relW_thisMonth: "This month (whole)",
  relW_thisQuarter: "This quarter (whole)",
  relW_thisYear: "This year (whole)",
  rel_lastYear: "Last year",
  relLastN_day: "Last {{n}} days",
  relLastN_week: "Last {{n}} weeks",
  relLastN_month: "Last {{n}} months",
  relLastN_year: "Last {{n}} years",
  relLast: "Last",
  relLastN: "How many",
  relUnit: "Unit",
  relUnit_day: "days",
  relUnit_week: "weeks",
  relUnit_month: "months",
  relUnit_year: "years",
  relHint: "Kept as a period, not as dates: a report saved with \"This month\" shows the current month whenever it is opened. \"This …\" runs to today.",
  relHintN: "Counted back from today, today included. Months and years are whole calendar ones: \"Last 12 months\" is this month and the 11 before it.",
  relBadN: "Enter a whole number from 1 to 400.",
  fMode_relative: "Relative period",
  fMode_range: "Between dates",
  fClearDates: "Clear the dates",
  sumRel: "{{field}}: {{period}}",
  vt_kpi: "KPI",
  vt_combo: "Line and column",
  vt_pie: "Pie",
  vt_donut: "Donut",
  w_indicator: "Value",
  w_trend: "Trend axis",
  w_colValues: "Column values",
  w_lineValues: "Line values",
  showAs: "Show value as",
  calc_none: "Value",
  calc_py: "Same period last year",
  calc_yoy: "Change vs last year",
  calc_yoy_pct: "Change vs last year %",
  calc_pm: "Same days last month",
  calc_mom: "Change vs last month",
  calc_mom_pct: "Change vs last month %",
  calc_share: "% of total",
  kpiTitle: "{{value}} vs last year",
  kpiNoLy: "No figure for the same days last year",
  kpiVsLy: "vs {{value}} last year",
  pieNegatives: "Negative figures are left out of the pie.",
  expandAll: "Expand all",
  collapseAll: "Collapse all",
  expand: "Expand",
  collapse: "Collapse",
  tab_build: "Build",
  tab_format: "Format",
  fmtShowTitle: "Show title",
  fmtNumbers: "Numbers",
  fmtUnits: "Display units",
  fmtUnits_default: "As the field",
  fmtUnits_auto: "Auto (1.2M)",
  fmtUnits_none: "None",
  fmtUnits_K: "Thousands (K)",
  fmtUnits_M: "Millions (M)",
  fmtUnits_B: "Billions (B)",
  fmtDecimals: "Decimal places",
  fmtAuto: "Auto",
  fmtChart: "Chart",
  fmtLabels: "Data labels",
  anchored: "Periods as of {{date}}",
  anchoredHint: "A date range chosen for this page or the report ends on {{date}}, so each visual's This year, Last week, This month… is counted from that day, not from today.",
  colAction: "Action",
  open: "Open",
  slicerPicked: "{{n}} selected",
  fmtSlicerStyle: "Style",
  fmtSlicer_list: "List",
  fmtSlicer_dropdown: "Dropdown",
  renameValue: "Rename for this visual",
  renamedFrom: "{{name}} — renamed from {{field}} in this visual",
  fmtLegend: "Legend",
  fmtLegend_top: "Top",
  fmtLegend_bottom: "Bottom",
  fmtLegend_right: "Right",
  fmtLegend_none: "Hidden",
  fmtColour: "Colour",
  fmtCond: "Conditional formatting",
  fmtCondKind: "Cells",
  fmtCond_none: "Plain",
  fmtCond_scale: "Colour scale",
  fmtCond_bars: "Data bars",
  fmtCondHint_scale: "Each cell is tinted by its size, darker for larger; a negative figure is tinted red. Totals stay plain.",
  fmtCondHint_bars: "Each cell carries a bar as long as its share of the largest figure in the table. Totals stay plain.",
  fmtReset: "Back to the default format",
};

const ko = {
  // operations datasets — Samples, Project SKUs, Tickets (Max 31/10)
  ds_samples: "샘플",
  ds_skus: "프로젝트 SKU",
  ds_tickets: "티켓",
  group_status: "상태",
  group_people: "담당자",
  group_checks: "누락 정보",
  sw_allRounds: "모든 라운드 (현재 라운드만이 아님)",
  f_request_date: "요청일",
  f_due_date: "개발 마감일 (Development Due)",
  f_sent_date: "발송일",
  f_state: "진행 상태",
  f_late_state: "정시 / 지연",
  f_due_bucket: "마감 시점",
  f_rm_state: "원자재 (RM)",
  f_outcome: "결과",
  f_rework_reason: "재작업 사유",
  f_round: "라운드",
  f_developer: "개발 담당",
  f_designer: "디자이너",
  f_location: "제작처",
  f_team: "Sales OP 팀",
  f_project: "프로젝트",
  f_sample: "샘플",
  f_season: "시즌",
  f_rounds: "라운드 수",
  f_samples_count: "샘플 수",
  f_in_work: "제작 중",
  f_waiting_comment: "코멘트 대기",
  f_overdue_not_sent: "지연 (미발송)",
  f_sent_late: "지연 발송",
  f_sent_on_time: "정시 발송",
  f_days_late: "지연 일수",
  f_make_days: "제작 일수",
  f_round_cycle_days: "라운드 주기 (일)",
  f_exf_date: "EXF 날짜",
  f_created_date: "생성일",
  f_status: "상태",
  f_sku_approval: "SKU 승인",
  f_project_approval: "프로젝트 승인",
  f_exf_bucket: "EXF 시점",
  f_order_kind: "신규 / 리오더",
  f_has_remark: "비고",
  f_chk_exf: "EXF 날짜",
  f_chk_developer: "개발 담당",
  f_chk_designer: "디자이너",
  f_chk_sales_rep: "영업 담당",
  f_chk_season: "시즌",
  f_chk_launch: "출시 월",
  f_owner: "프로젝트 오너",
  f_sales_rep: "영업 담당",
  f_vendor: "벤더",
  f_project_category: "프로젝트 카테고리",
  f_launch_month: "출시 월",
  f_project_count: "프로젝트 수",
  f_skus_missing_info: "정보 누락 SKU",
  f_missing_fields: "누락 항목 수",
  f_closed_date: "종료일",
  f_team_reply: "담당팀 회신",
  f_due_state: "마감 상태",
  f_ticket_code: "티켓 코드",
  f_receiving_team: "수신 팀",
  f_assignee: "담당자",
  f_requester: "요청자",
  f_ticket: "티켓",
  f_ticket_count: "티켓 수",
  f_open_tickets: "진행 중 티켓",
  f_overdue_tickets: "지연 티켓",
  f_days_to_close: "처리 일수",
  f_days_open: "경과 일수",
  title: '데이터 탐색',
  asOf: '{{date}}까지의 데이터',
  dataset: '데이터셋',
  ds_sales: '매출',
  ds_inventory: '재고',
  ds_marketing: "마케팅",
  group_channel: "채널",
  f_mkt_date: "일자",
  f_market: "시장",
  f_mkt_channel: "채널 유형",
  f_mkt_platform: "플랫폼",
  f_mkt_account: "계정",
  f_campaign: "캠페인",
  f_mkt_currency: "계정 통화",
  f_ad_spend: "광고비",
  f_impressions: "노출수",
  f_ad_clicks: "클릭수",
  f_ctr: "CTR",
  f_cpc: "클릭당 비용",
  f_cpm: "1,000회 노출당 비용",
  f_attributed_revenue: "광고 기여 매출(플랫폼 기준)",
  f_attributed_orders: "광고 기여 구매(플랫폼 기준)",
  f_roas: "ROAS(플랫폼 기준)",
  f_email_revenue: "이메일 매출(Klaviyo)",
  f_email_orders: "이메일 주문(Klaviyo)",
  f_sessions: "웹 세션(GA4)",
  f_web_revenue: "웹 매출(GA4)",
  f_web_orders: "웹 주문(GA4)",
  f_web_conversion: "웹 전환율",
  f_store_sales: "스토어 매출(Shopify)",
  f_store_orders: "스토어 주문(Shopify)",
  f_mer: "스토어 매출 ÷ 광고비",
  f_spend_share: "광고비 ÷ 스토어 매출",
  ds_pole_position: "폴 현재 현황",
  f_snap_date: "스냅샷 일자",
  f_base_month: "마감 월",
  f_line_kind: "행 구분",
  f_po_due: "미입고 PO 납기",
  f_pole_family: "프레임 패밀리",
  f_end_qty: "마감 월말 재고",
  f_received_qty: "이후 입고",
  f_to_group_qty: "이후 타 법인 출고",
  f_sold_qty: "이후 판매",
  f_other_qty: "기타 변동",
  f_now_qty: "현재 재고",
  f_po_total_qty: "미입고 PO (합계)",
  f_po_qty: "미입고 PO 수량",
  f_avg_month_sales: "월평균 판매 (3개월)",
  f_months_of_stock: "재고 개월수",
  f_months_with_po: "재고 개월수 (PO 포함)",
  group_stock: '재고',
  f_snapshot: '스냅샷 날짜',
  f_day_kind: '날짜 구분(금요일 = 주차)',
  f_latest_day: '최신 날짜',
  f_ageing: '재고 연령',
  f_stock_kind: '보유 / 운송 중',
  f_line_status: '라인 상태',
  f_inbound_year: '입고 연도',
  f_brand: '브랜드',
  f_goods_type: '품목 유형',
  f_inv_category: '카테고리',
  f_inv_subcategory: '하위 카테고리',
  f_family: '패밀리',
  f_size_class: '사이즈 구분',
  f_consignment: '일반 / 위탁',
  f_product: '제품',
  f_color: '색상',
  f_stock_amount: '보유 금액(USD)',
  f_stock_qty: '보유 수량',
  f_transit_amount: '운송 중 금액(USD)',
  f_transit_qty: '운송 중 수량',
  f_over1y_share: '1년 초과 금액 비중',
  f_avg_age: '평균 연령(일)',
  sw_allDays: '모든 스냅샷 날짜',
  fieldSearch: '필드 찾기…',
  group_time: '기간',
  group_product: '제품',
  group_org: '법인·채널',
  group_geo: '지역',
  group_measures: '값',
  f_date: '날짜',
  f_line: '라인',
  f_category: '제품 카테고리',
  f_type: '제품 유형',
  f_subtype: '제품 세부 유형',
  f_frame_model: '프레임 모델',
  f_frame_color: '프레임 색상',
  f_sku: 'SKU',
  f_entity_group: '법인 그룹',
  f_entity: '법인',
  f_channel: '채널',
  f_channel2: '하위 채널',
  f_channel3: '채널 상세',
  f_customer: '고객',
  f_region: '권역',
  f_subregion: '세부 권역',
  f_country: '국가',
  f_revenue: '매출액',
  f_quantity: '수량',
  f_avg_price: '평균 단가',
  f_sku_count: 'SKU 수',
  f_customer_count: '고객 수',
  f_lines: '거래 라인 수',
  f_target: '목표',
  f_achievement: '달성률 %',
  f_vs_target: '목표 대비',
  vt_map: '지도',
  w_location: '위치',
  w_mapColor: '색상 기준',
  mapNeedsGeo: '지도에는 국가, 세부 권역 또는 권역이 필요합니다. 위치에 하나를 넣으세요.',
  mapNone: '값 없음',
  mapUnplaced: '지도에 없음 ({{n}}): {{names}}',
  fmtTopN: '표시',
  fmtTopN_all: '모든 행',
  fmtTopN_n: '상위 {{n}}',
  topNote: '첫 번째 값 기준 {{total}}개 중 상위 {{n}}개.',
  topNoteTable: '첫 번째 값 기준 {{total}}개 중 상위 {{n}}개. 합계 행은 전체를 셉니다.',
  targetBlocked: '목표 없음: 목표는 날짜, 법인 그룹, 법인, 채널로만 설정되어 있으며 {{fields}} 기준은 없습니다.',
  targetBlockedShort: '{{fields}} 기준 목표 없음',
  relWholeN: '완료된 기간만',
  relWholeOpt: '기간 끝까지 (목표는 기간 전체)',
  relWholeNOpt: '완료된 기간만 (현재 기간 제외)',
  relHintWhole: '기간 시작부터 끝까지. 매출은 마지막으로 반영된 날까지, 목표는 기간 끝까지입니다 — Sales Report가 월 누계를 월 전체 목표와 비교하는 방식입니다.',
  relHintNWhole: '현재 기간 이전의 완료된 기간: "최근 5주"는 이번 주 이전 5주(월~일)입니다.',
  g_year: '연',
  g_quarter: '분기',
  g_month: '월',
  g_week: '주',
  g_day: '일',
  a_sum: '합계',
  a_avg: '평균',
  a_min: '최소',
  a_max: '최대',
  dropHere: '여기로 필드를 끌어 놓으세요',
  remove: '삭제',
  sw_includeInternal: '관계사 간 매출',
  sw_includeOversea: '해외(Oversea) 매출',
  currency: '통화',
  chartTop: '차트는 {{total}}개 행 중 처음 {{n}}개를 보여줍니다.',
  other: '기타',
  total: '합계',
  loading: '처리 중…',
  truncated: '큰 순서로 {{n}}개 그룹만 표시합니다. 나머지를 보려면 필터를 추가하세요.',
  tooManyCols: '{{total}}개 열 중 큰 순서로 {{n}}개만 표시합니다. 다른 열을 보려면 열 필드에 필터를 거세요.',
  moreRows: '{{n}}개 행 더 보기',
  drillUp: '한 단계 위로',
  drillInto: '{{value}}(으)로 드릴다운',
  fInclude: '포함',
  fExclude: '제외',
  fContains: '텍스트 포함',
  fSearch: '값 검색…',
  fSelectShown: '보이는 항목 모두 선택',
  fClear: '선택 해제',
  fApply: '적용',
  fCancel: '취소',
  fMore: '처음 500개만 표시합니다. 다른 값은 검색하세요.',
  fNone: '일치하는 값이 없습니다.',
  fFrom: '시작',
  fTo: '종료',
  fAll: '전체 기간',
  fSelected: '{{n}}개 선택',
  containsText: '값에 포함된 텍스트',
  sumIn: '{{field}}: {{values}}',
  sumNotIn: '{{field}}: {{values}} 제외',
  sumMore: '외 {{n}}개',
  sumContains: '{{field}}에 “{{text}}” 포함',
  sumRange: '{{field}}: {{from}} – {{to}}',
  sumFrom: '{{field}}: {{from}}부터',
  sumTo: '{{field}}: {{to}}까지',
  sumAll: '{{field}}: 전체',
  save: '저장',
  saveAs: '다른 이름으로 저장…',
  rename: '이름 변경',
  share: "공유",
  delete: '삭제',
  unsaved: '저장되지 않은 변경',
  saved: '저장됨',
  copyLink: '링크 복사',
  linkCopied: '링크를 복사했습니다',
  by: '작성: {{name}}',
  confirmDelete: '“{{name}}”을(를) 삭제할까요? 되돌릴 수 없습니다.',
  sharedBadge: '공유',
  errLoad: '데이터 탐색을 불러오지 못했습니다.',
  errNoDatasets: '열람 가능한 데이터셋이 아직 없습니다. 관리자에게 권한을 요청하세요.',
  reports: "보고서",
  myReports: "내 보고서",
  sharedReports: "나와 공유됨",
  noReports: "저장된 보고서가 없습니다.",
  newReport: "새 보고서",
  untitled: "제목 없는 보고서",
  reportName: "보고서 이름",
  editMode: "편집",
  readMode: "읽기 보기",
  refresh: "데이터 다시 읽기",
  clearSelection: "선택 해제",
  emptyVisual: "데이터 창에서 필드를 골라 이 시각화를 만드세요.",
  emptyPage: "빈 페이지입니다. 시각화 창에서 종류를 고르거나 데이터 창에서 필드를 체크하세요.",
  emptyPageRead: "빈 페이지입니다.",
  tooManyVisuals: "한 페이지에는 시각화를 최대 {{n}}개까지 둘 수 있습니다.",
  drillMode: "드릴다운: 클릭하면 한 단계 아래로",
  nextLevel: "다음 수준으로",
  moreOptions: "추가 옵션",
  showTable: "표로 보기",
  showVisual: "시각화로 보기",
  focus: "포커스 모드",
  backToReport: "보고서로 돌아가기",
  exportData: "데이터 내보내기 (Excel)",
  duplicate: "복제",
  removeVisual: "삭제",
  presets: "빠른 기간…",
  slicerAll: "전체",
  dataPane: "데이터",
  visPane: "시각화",
  filtersPane: "필터",
  newVisual: "추가",
  visHint: "종류를 골라 시각화를 추가하거나, 페이지의 시각화를 클릭해 바꾸세요.",
  vt_card: "카드",
  vt_table: "표",
  vt_matrix: "행렬",
  vt_column: "세로 막대형 차트",
  vt_stacked: "누적 세로 막대형 차트",
  vt_bar: "가로 막대형 차트",
  vt_line: "꺾은선형 차트",
  vt_area: "영역형 차트",
  vt_slicer: "슬라이서",
  w_fields: "필드",
  w_columns: "열",
  w_rows: "행",
  w_cols: "열",
  w_values: "값",
  w_xaxis: "X축",
  w_legend: "범례",
  w_yaxis: "Y축",
  w_yaxisCat: "Y축",
  w_xaxisVal: "X축",
  w_field: "필드",
  vTitle: "제목",
  grain: "날짜 단위",
  dateRange: "날짜 범위",
  aggregation: "집계",
  filtersVisual: "이 시각화의 필터",
  filtersPage: "이 페이지의 필터",
  filtersAll: "모든 페이지의 필터",
  addFilter: "필터 추가",
  pages: "페이지",
  pageN: "페이지 {{n}}",
  addPage: "새 페이지",
  pageOptions: "페이지 옵션",
  pageTabHint: "두 번 클릭하여 이름 바꾸기",
  renamePage: "페이지 이름 바꾸기",
  duplicatePage: "페이지 복제",
  moveLeft: "왼쪽으로 이동",
  moveRight: "오른쪽으로 이동",
  deletePage: "페이지 삭제",
  confirmDeletePage: "“{{name}}” 페이지와 그 시각화를 삭제할까요?",
  confirmNewDataset: "다른 데이터셋을 고르면 새 보고서가 시작됩니다. 먼저 저장하지 않으면 지금 보고서는 사라집니다. 계속할까요?",
  titleBy: "{{dims}}별 {{values}}",
  titleAnd: ", ",
  undo: "실행 취소 (Ctrl+Z)",
  redo: "다시 실행 (Ctrl+Y)",
  pageDeleted: "페이지를 삭제했습니다 — 실행 취소로 되돌릴 수 있습니다.",
  allReports: "모든 보고서",
  homeAll: "전체",
  homeMine: "내 보고서",
  homeShared: "나와 공유됨",
  homeSearch: "보고서 찾기…",
  colName: "이름",
  colOwner: "소유자",
  colSharedWith: "공유 대상",
  colUpdated: "마지막 변경",
  you: "나",
  sharedWithYou: "나와 공유됨",
  sharedBy: "{{name}} 님이 공유",
  privateOnly: "비공개",
  everyone: "모든 사람",
  everyoneHint: "{{ds}} 데이터를 볼 수 있는 모든 사람",
  nPeople: "{{n}}명",
  homeEmptyMine: "아직 보고서가 없습니다. 새 보고서를 눌러 만드세요.",
  homeEmptyShared: "아직 나와 공유된 보고서가 없습니다.",
  homeEmptySearch: "일치하는 보고서가 없습니다.",
  continueDraft: "이어서 작업하기",
  draftNew: "아직 저장하지 않은 새 보고서",
  draftChanged: "“{{name}}”의 저장하지 않은 변경",
  continue: "계속",
  discardDraft: "버리기",
  confirmDiscard: "“{{name}}”의 저장하지 않은 변경을 버릴까요?",
  shareTitle: "“{{name}}” 공유",
  shareSearch: "사람, 부서 또는 법인 추가…",
  kind_all: "모든 사람",
  kind_team: "부서",
  kind_entity: "법인",
  oneTeam: "부서",
  oneEntity: "법인",
  kind_user: "사람",
  sharePrivate: "비공개 — 나만 열 수 있습니다.",
  shareReach: "{{n}}명이 보게 됩니다.",
  shareCannot: "여기 지정된 {{n}}명은 아직 {{ds}} 데이터를 볼 권한이 없어, 권한을 받을 때까지 보고서가 보이지 않습니다:",
  noAccessTag: "데이터 권한 없음",
  noAccessHint: "아직 {{ds}} 데이터 권한이 없습니다 — 권한을 받기 전에는 보고서를 볼 수 없습니다.",
  shareNote: "받은 사람은 읽기만 합니다. 필터와 슬라이서는 자신의 화면만 바꿉니다. 보고서는 나만 바꿀 수 있고, 보고서를 만드는 사람은 사본을 저장할 수 있습니다.",
  makePrivate: "비공개로",
  shareSaved: "공유를 저장했습니다",
  shareSaveFirst: "먼저 보고서를 저장한 뒤 공유하세요.",
  removeShare: "제거",
  peopleWithAccess: "액세스 권한이 있는 사용자",
  generalAccess: "일반 액세스",
  youMark: "(나)",
  roleOwner: "소유자",
  roleViewer: "뷰어",
  roleEditor: "편집자",
  roleHead: "역할",
  transferOwnership: "소유권 이전",
  transferNoBuild: "{{name}} 님은 보고서를 만들 수 없어(Data Explorer 권한 없음) 소유자가 될 수 없습니다.",
  transferNoData: "{{name}} 님은 아직 {{ds}} 데이터를 볼 수 없습니다.",
  transferAsk: "{{name}} 님을 소유자로 지정할까요?",
  transferHint: "나는 편집자로 남습니다. 새 소유자만 공유, 삭제, 다시 이전할 수 있습니다.",
  transferGo: "이전",
  transferDone: "이제 {{name}} 님이 보고서의 소유자입니다 — 나는 편집자로 남습니다.",
  roleOf: "권한",
  removeAccess: "액세스 권한 삭제",
  genRestricted: "제한됨",
  genRestrictedHint: "위에 추가된 사용자만 링크로 열 수 있습니다",
  genEveryone: "{{ds}} 데이터를 볼 수 있는 모든 사람",
  genEveryoneHint: "{{ds}} 데이터를 볼 수 있는 Helinox 직원은 누구나 열어 볼 수 있습니다",
  copyLink: "링크 복사",
  linkCopied: "링크를 복사했습니다",
  shareDone: "완료",
  noMatch: "일치하는 항목이 없습니다.",
  notFound: "보고서가 없거나 나와 공유되지 않았습니다.",
  deleted: "보고서를 삭제했습니다",
  fBackwards: "종료일이 시작일보다 앞입니다.",
  nPerson: "1명",
  shareReachOne: "1명이 보게 됩니다.",
  rel_today: "오늘",
  rel_yesterday: "어제",
  rel_thisWeek: "이번 주",
  rel_lastWeek: "지난주",
  rel_thisMonth: "이번 달 (오늘까지)",
  rel_lastMonth: "지난달",
  rel_thisQuarter: "이번 분기 (오늘까지)",
  rel_lastQuarter: "지난 분기",
  rel_thisYear: "올해 (오늘까지)",
  relW_thisWeek: "이번 주 (전체)",
  relW_thisMonth: "이번 달 (전체)",
  relW_thisQuarter: "이번 분기 (전체)",
  relW_thisYear: "올해 (전체)",
  rel_lastYear: "작년",
  relLastN_day: "최근 {{n}}일",
  relLastN_week: "최근 {{n}}주",
  relLastN_month: "최근 {{n}}개월",
  relLastN_year: "최근 {{n}}년",
  relLast: "최근",
  relLastN: "개수",
  relUnit: "단위",
  relUnit_day: "일",
  relUnit_week: "주",
  relUnit_month: "개월",
  relUnit_year: "년",
  relHint: "날짜가 아니라 기간으로 저장됩니다. \"이번 달\"로 저장한 보고서는 열 때마다 그 달을 보여줍니다. \"이번 …\"은 오늘까지입니다.",
  relHintN: "오늘을 포함해 오늘부터 거슬러 셉니다. 월과 연은 달력 단위입니다: \"최근 12개월\" = 이번 달과 그 앞 11개월.",
  relBadN: "1에서 400 사이의 정수를 입력하세요.",
  fMode_relative: "상대 기간",
  fMode_range: "날짜 사이",
  fClearDates: "날짜 지우기",
  sumRel: "{{field}}: {{period}}",
  vt_kpi: "KPI",
  vt_combo: "꺾은선 및 세로 막대",
  vt_pie: "원형",
  vt_donut: "도넛",
  w_indicator: "값",
  w_trend: "추세 축",
  w_colValues: "막대 값",
  w_lineValues: "꺾은선 값",
  showAs: "값 표시 방식",
  calc_none: "값",
  calc_py: "전년 동기",
  calc_yoy: "전년 대비 증감",
  calc_yoy_pct: "전년 대비 증감 %",
  calc_pm: "전월 동기",
  calc_mom: "전월 대비 증감",
  calc_mom_pct: "전월 대비 증감 %",
  calc_share: "전체 대비 %",
  kpiTitle: "{{value}} 전년 대비",
  kpiNoLy: "작년 같은 기간의 수치가 없습니다",
  kpiVsLy: "작년 {{value}} 대비",
  pieNegatives: "음수는 원형 차트에서 제외됩니다.",
  expandAll: "모두 펼치기",
  collapseAll: "모두 접기",
  expand: "펼치기",
  collapse: "접기",
  tab_build: "구성",
  tab_format: "서식",
  fmtShowTitle: "제목 표시",
  fmtNumbers: "숫자",
  fmtUnits: "표시 단위",
  fmtUnits_default: "필드 기본",
  fmtUnits_auto: "자동 (1.2M)",
  fmtUnits_none: "없음",
  fmtUnits_K: "천 (K)",
  fmtUnits_M: "백만 (M)",
  fmtUnits_B: "십억 (B)",
  fmtDecimals: "소수 자릿수",
  fmtAuto: "자동",
  fmtChart: "차트",
  fmtLabels: "데이터 레이블",
  anchored: "기준일 {{date}}",
  anchoredHint: "이 페이지나 보고서에 선택한 날짜 범위가 {{date}}에 끝나므로, 각 시각화의 올해·지난주·이번 달…은 오늘이 아니라 그날을 기준으로 계산됩니다.",
  colAction: "작업",
  open: "열기",
  slicerPicked: "{{n}}개 선택",
  fmtSlicerStyle: "스타일",
  fmtSlicer_list: "목록",
  fmtSlicer_dropdown: "드롭다운",
  renameValue: "이 시각화에서 이름 바꾸기",
  renamedFrom: "{{name}} — 이 시각화에서 {{field}}의 이름을 바꿈",
  fmtLegend: "범례",
  fmtLegend_top: "위",
  fmtLegend_bottom: "아래",
  fmtLegend_right: "오른쪽",
  fmtLegend_none: "숨김",
  fmtColour: "색상",
  fmtCond: "조건부 서식",
  fmtCondKind: "셀",
  fmtCond_none: "없음",
  fmtCond_scale: "색 눈금",
  fmtCond_bars: "데이터 막대",
  fmtCondHint_scale: "셀마다 크기에 따라 색을 입힙니다. 클수록 진하고, 음수는 빨간색입니다. 합계는 그대로입니다.",
  fmtCondHint_bars: "셀마다 표에서 가장 큰 수치 대비 비율만큼 막대를 그립니다. 합계는 그대로입니다.",
  fmtReset: "기본 서식으로 되돌리기",
};

const vi = {
  // operations datasets — Samples, Project SKUs, Tickets (Max 31/10)
  ds_samples: "Mẫu (Samples)",
  ds_skus: "SKU dự án",
  ds_tickets: "Ticket",
  group_status: "Trạng thái",
  group_people: "Người phụ trách",
  group_checks: "Thiếu thông tin",
  sw_allRounds: "Mọi round (không chỉ round hiện tại)",
  f_request_date: "Ngày yêu cầu",
  f_due_date: "Development Due",
  f_sent_date: "Ngày gửi",
  f_state: "Tình trạng",
  f_late_state: "Đúng hạn / trễ",
  f_due_bucket: "Hạn khi nào",
  f_rm_state: "Nguyên liệu (RM)",
  f_outcome: "Kết quả",
  f_rework_reason: "Lý do làm lại",
  f_round: "Round",
  f_developer: "Developer",
  f_designer: "Designer",
  f_location: "Nơi làm",
  f_team: "Team Sales OP",
  f_project: "Dự án",
  f_sample: "Mẫu",
  f_season: "Mùa",
  f_rounds: "Số round",
  f_samples_count: "Số mẫu",
  f_in_work: "Đang làm",
  f_waiting_comment: "Chờ comment",
  f_overdue_not_sent: "Trễ, chưa gửi",
  f_sent_late: "Gửi trễ",
  f_sent_on_time: "Gửi đúng hạn",
  f_days_late: "Số ngày trễ",
  f_make_days: "Số ngày làm",
  f_round_cycle_days: "Chu kỳ round (ngày)",
  f_exf_date: "Ngày EXF",
  f_created_date: "Ngày tạo",
  f_status: "Trạng thái",
  f_sku_approval: "Duyệt SKU",
  f_project_approval: "Duyệt dự án",
  f_exf_bucket: "EXF khi nào",
  f_order_kind: "Mới / đơn lặp lại",
  f_has_remark: "Ghi chú",
  f_chk_exf: "Ngày EXF",
  f_chk_developer: "Developer",
  f_chk_designer: "Designer",
  f_chk_sales_rep: "Sales rep",
  f_chk_season: "Mùa",
  f_chk_launch: "Tháng ra mắt",
  f_owner: "Chủ dự án",
  f_sales_rep: "Sales rep",
  f_vendor: "Vendor",
  f_project_category: "Nhóm dự án",
  f_launch_month: "Tháng ra mắt",
  f_project_count: "Số dự án",
  f_skus_missing_info: "SKU thiếu thông tin",
  f_missing_fields: "Số mục thiếu",
  f_closed_date: "Ngày đóng",
  f_team_reply: "Team trả lời",
  f_due_state: "Tình trạng hạn",
  f_ticket_code: "Mã ticket",
  f_receiving_team: "Team nhận",
  f_assignee: "Người được giao",
  f_requester: "Người yêu cầu",
  f_ticket: "Ticket",
  f_ticket_count: "Số ticket",
  f_open_tickets: "Ticket đang mở",
  f_overdue_tickets: "Ticket quá hạn",
  f_days_to_close: "Số ngày để đóng",
  f_days_open: "Số ngày đang mở",
  title: 'Khám phá dữ liệu',
  asOf: 'Dữ liệu đến {{date}}',
  dataset: 'Bộ dữ liệu',
  ds_sales: 'Doanh số',
  ds_inventory: 'Tồn kho',
  ds_marketing: "Marketing",
  group_channel: "Kênh",
  f_mkt_date: "Ngày",
  f_market: "Thị trường",
  f_mkt_channel: "Loại kênh",
  f_mkt_platform: "Nền tảng",
  f_mkt_account: "Tài khoản",
  f_campaign: "Chiến dịch",
  f_mkt_currency: "Tiền tệ tài khoản",
  f_ad_spend: "Chi phí quảng cáo",
  f_impressions: "Lượt hiển thị",
  f_ad_clicks: "Lượt nhấp",
  f_ctr: "CTR",
  f_cpc: "Chi phí mỗi lượt nhấp",
  f_cpm: "Chi phí mỗi 1.000 hiển thị",
  f_attributed_revenue: "Doanh thu quảng cáo tự báo",
  f_attributed_orders: "Đơn mua quảng cáo tự báo",
  f_roas: "ROAS (nền tảng báo)",
  f_email_revenue: "Doanh thu email (Klaviyo)",
  f_email_orders: "Đơn hàng email (Klaviyo)",
  f_sessions: "Phiên web (GA4)",
  f_web_revenue: "Doanh thu web (GA4)",
  f_web_orders: "Đơn hàng web (GA4)",
  f_web_conversion: "Tỷ lệ chuyển đổi web",
  f_store_sales: "Doanh số cửa hàng (Shopify)",
  f_store_orders: "Đơn hàng cửa hàng (Shopify)",
  f_mer: "Doanh số ÷ chi phí QC",
  f_spend_share: "Chi phí QC ÷ doanh số",
  ds_pole_position: "Tình hình khung hiện tại",
  f_snap_date: "Ngày chụp",
  f_base_month: "Tháng đã chốt",
  f_line_kind: "Loại dòng",
  f_po_due: "Hạn PO đang mở",
  f_pole_family: "Dòng khung",
  f_end_qty: "Tồn cuối tháng đã chốt",
  f_received_qty: "Đã nhập từ đó",
  f_to_group_qty: "Chuyển entity khác từ đó",
  f_sold_qty: "Đã bán từ đó",
  f_other_qty: "Biến động khác",
  f_now_qty: "Tồn hôm nay",
  f_po_total_qty: "PO đang mở (tổng)",
  f_po_qty: "SL PO đang mở",
  f_avg_month_sales: "Bán TB tháng (3 tháng)",
  f_months_of_stock: "Số tháng tồn",
  f_months_with_po: "Số tháng tồn gồm PO",
  group_stock: 'Tồn kho',
  f_snapshot: 'Ngày chụp',
  f_day_kind: 'Loại ngày (thứ Sáu = tuần)',
  f_latest_day: 'Ngày mới nhất',
  f_ageing: 'Tuổi hàng',
  f_stock_kind: 'Tồn / đang về',
  f_line_status: 'Line status',
  f_inbound_year: 'Năm nhập kho',
  f_brand: 'Thương hiệu',
  f_goods_type: 'Loại hàng',
  f_inv_category: 'Nhóm',
  f_inv_subcategory: 'Nhóm con',
  f_family: 'Dòng (family)',
  f_size_class: 'Cỡ',
  f_consignment: 'Hàng mình / ký gửi',
  f_product: 'Sản phẩm',
  f_color: 'Màu',
  f_stock_amount: 'Giá trị tồn (USD)',
  f_stock_qty: 'Số lượng tồn',
  f_transit_amount: 'Giá trị đang về (USD)',
  f_transit_qty: 'Số lượng đang về',
  f_over1y_share: 'Tỷ lệ giá trị trên 1 năm',
  f_avg_age: 'Tuổi trung bình (ngày)',
  sw_allDays: 'Mọi ngày đã chụp',
  fieldSearch: 'Tìm trường…',
  group_time: 'Thời gian',
  group_product: 'Sản phẩm',
  group_org: 'Entity & kênh',
  group_geo: 'Địa lý',
  group_measures: 'Giá trị',
  f_date: 'Ngày',
  f_line: 'Line',
  f_category: 'Nhóm sản phẩm',
  f_type: 'Loại sản phẩm',
  f_subtype: 'Loại phụ sản phẩm',
  f_frame_model: 'Mẫu khung',
  f_frame_color: 'Màu khung',
  f_sku: 'SKU',
  f_entity_group: 'Nhóm entity',
  f_entity: 'Entity',
  f_channel: 'Kênh',
  f_channel2: 'Kênh phụ',
  f_channel3: 'Chi tiết kênh',
  f_customer: 'Khách hàng',
  f_region: 'Vùng',
  f_subregion: 'Tiểu vùng',
  f_country: 'Quốc gia',
  f_revenue: 'Doanh thu',
  f_quantity: 'Số lượng',
  f_avg_price: 'Đơn giá bình quân',
  f_sku_count: 'Số SKU',
  f_customer_count: 'Số khách hàng',
  f_lines: 'Số dòng giao dịch',
  f_target: 'Mục tiêu',
  f_achievement: 'Tỷ lệ đạt %',
  f_vs_target: 'So với mục tiêu',
  vt_map: 'Bản đồ',
  w_location: 'Vị trí',
  w_mapColor: 'Tô màu theo',
  mapNeedsGeo: 'Bản đồ cần Quốc gia, Tiểu vùng hoặc Vùng. Hãy đặt một trường vào Vị trí.',
  mapNone: 'Không có giá trị',
  mapUnplaced: 'Không có trên bản đồ ({{n}}): {{names}}',
  fmtTopN: 'Hiển thị',
  fmtTopN_all: 'Tất cả các dòng',
  fmtTopN_n: 'Top {{n}}',
  topNote: 'Top {{n}} trong {{total}} theo giá trị đầu tiên.',
  topNoteTable: 'Top {{n}} trong {{total}} theo giá trị đầu tiên; dòng tổng tính tất cả.',
  targetBlocked: 'Không có mục tiêu ở đây: mục tiêu chỉ đặt theo ngày, nhóm entity, entity và kênh, không theo {{fields}}.',
  targetBlockedShort: 'Không có mục tiêu theo {{fields}}',
  relWholeN: 'chỉ kỳ đã xong',
  relWholeOpt: 'Đến hết kỳ (mục tiêu tính cả kỳ)',
  relWholeNOpt: 'Chỉ các kỳ đã trọn (bỏ kỳ hiện tại)',
  relHintWhole: 'Từ đầu kỳ đến hết kỳ. Doanh số dừng ở ngày dữ liệu mới nhất; mục tiêu tính đến hết kỳ — như Sales Report so doanh số lũy kế tháng với mục tiêu cả tháng.',
  relHintNWhole: 'Các kỳ trọn trước kỳ hiện tại: "5 tuần gần nhất" là 5 tuần trước tuần này, thứ Hai đến Chủ nhật.',
  g_year: 'Năm',
  g_quarter: 'Quý',
  g_month: 'Tháng',
  g_week: 'Tuần',
  g_day: 'Ngày',
  a_sum: 'Tổng',
  a_avg: 'Trung bình',
  a_min: 'Nhỏ nhất',
  a_max: 'Lớn nhất',
  dropHere: 'Kéo trường vào đây',
  remove: 'Bỏ',
  sw_includeInternal: 'Doanh số nội bộ công ty',
  sw_includeOversea: 'Doanh số Oversea',
  currency: 'Đơn vị tiền',
  chartTop: 'Biểu đồ thể hiện {{n}} dòng đầu trong {{total}} dòng.',
  other: 'Khác',
  total: 'Tổng',
  loading: 'Đang xử lý…',
  truncated: 'Chỉ hiện {{n}} nhóm lớn nhất. Thêm bộ lọc để xem phần còn lại.',
  tooManyCols: 'Đang hiện {{n}} cột lớn nhất trong {{total}} cột. Lọc trường ở cột để chọn cột khác.',
  moreRows: 'Hiện thêm {{n}} dòng',
  drillUp: 'Lên một cấp',
  drillInto: 'Đi sâu vào {{value}}',
  fInclude: 'Gồm',
  fExclude: 'Loại trừ',
  fContains: 'Có chứa',
  fSearch: 'Tìm giá trị…',
  fSelectShown: 'Chọn hết đang hiện',
  fClear: 'Bỏ chọn',
  fApply: 'Áp dụng',
  fCancel: 'Hủy',
  fMore: 'Chỉ liệt kê 500 giá trị đầu. Tìm để thấy giá trị khác.',
  fNone: 'Không có giá trị nào khớp.',
  fFrom: 'Từ',
  fTo: 'Đến',
  fAll: 'Mọi ngày',
  fSelected: 'Đã chọn {{n}}',
  containsText: 'Chữ có trong giá trị',
  sumIn: '{{field}}: {{values}}',
  sumNotIn: '{{field}}: trừ {{values}}',
  sumMore: '+{{n}} giá trị khác',
  sumContains: '{{field}} có chứa “{{text}}”',
  sumRange: '{{field}}: {{from}} – {{to}}',
  sumFrom: '{{field}}: từ {{from}}',
  sumTo: '{{field}}: đến {{to}}',
  sumAll: '{{field}}: tất cả',
  save: 'Lưu',
  saveAs: 'Lưu thành…',
  rename: 'Đổi tên',
  share: "Chia sẻ",
  delete: 'Xóa',
  unsaved: 'Có thay đổi chưa lưu',
  saved: 'Đã lưu',
  copyLink: 'Sao chép link',
  linkCopied: 'Đã sao chép link',
  by: 'của {{name}}',
  confirmDelete: 'Xóa “{{name}}”? Không thể hoàn tác.',
  sharedBadge: 'Đã chia sẻ',
  errLoad: 'Không tải được Khám phá dữ liệu.',
  errNoDatasets: 'Bạn chưa được mở bộ dữ liệu nào. Hãy xin quyền từ admin.',
  reports: "Báo cáo",
  myReports: "Báo cáo của tôi",
  sharedReports: "Được chia sẻ với tôi",
  noReports: "Chưa có báo cáo nào được lưu.",
  newReport: "Báo cáo mới",
  untitled: "Báo cáo chưa đặt tên",
  reportName: "Tên báo cáo",
  editMode: "Chỉnh sửa",
  readMode: "Chế độ xem",
  refresh: "Đọc lại dữ liệu",
  clearSelection: "Bỏ chọn",
  emptyVisual: "Chọn trường ở ô Dữ liệu để dựng biểu đồ này.",
  emptyPage: "Trang này đang trống. Chọn một loại ở ô Trực quan hóa, hoặc đánh dấu một trường ở ô Dữ liệu.",
  emptyPageRead: "Trang này đang trống.",
  tooManyVisuals: "Mỗi trang có tối đa {{n}} biểu đồ.",
  drillMode: "Đi sâu: nhấp để xuống một cấp",
  nextLevel: "Xuống cấp tiếp theo",
  moreOptions: "Tùy chọn khác",
  showTable: "Xem dạng bảng",
  showVisual: "Xem dạng biểu đồ",
  focus: "Phóng to",
  backToReport: "Quay lại báo cáo",
  exportData: "Xuất dữ liệu (Excel)",
  duplicate: "Nhân bản",
  removeVisual: "Xóa",
  presets: "Khoảng nhanh…",
  slicerAll: "Tất cả",
  dataPane: "Dữ liệu",
  visPane: "Trực quan hóa",
  filtersPane: "Bộ lọc",
  newVisual: "Thêm",
  visHint: "Chọn một loại để thêm biểu đồ, hoặc nhấp vào biểu đồ trên trang để đổi.",
  vt_card: "Thẻ",
  vt_table: "Bảng",
  vt_matrix: "Ma trận",
  vt_column: "Biểu đồ cột",
  vt_stacked: "Biểu đồ cột chồng",
  vt_bar: "Biểu đồ thanh",
  vt_line: "Biểu đồ đường",
  vt_area: "Biểu đồ vùng",
  vt_slicer: "Bộ lọc nhanh",
  w_fields: "Trường",
  w_columns: "Cột",
  w_rows: "Hàng",
  w_cols: "Cột",
  w_values: "Giá trị",
  w_xaxis: "Trục X",
  w_legend: "Chú giải",
  w_yaxis: "Trục Y",
  w_yaxisCat: "Trục Y",
  w_xaxisVal: "Trục X",
  w_field: "Trường",
  vTitle: "Tiêu đề",
  grain: "Cấp thời gian",
  dateRange: "Khoảng ngày",
  aggregation: "Cách tổng hợp",
  filtersVisual: "Bộ lọc của biểu đồ này",
  filtersPage: "Bộ lọc của trang này",
  filtersAll: "Bộ lọc cho mọi trang",
  addFilter: "Thêm bộ lọc",
  pages: "Trang",
  pageN: "Trang {{n}}",
  addPage: "Trang mới",
  pageOptions: "Tùy chọn trang",
  pageTabHint: "Nhấp đúp để đổi tên",
  renamePage: "Đổi tên trang",
  duplicatePage: "Nhân bản trang",
  moveLeft: "Chuyển sang trái",
  moveRight: "Chuyển sang phải",
  deletePage: "Xóa trang",
  confirmDeletePage: "Xóa trang “{{name}}” cùng các biểu đồ trong đó?",
  confirmNewDataset: "Chọn bộ dữ liệu khác sẽ mở một báo cáo mới. Báo cáo đang mở sẽ mất nếu bạn chưa lưu. Tiếp tục?",
  titleBy: "{{values}} theo {{dims}}",
  titleAnd: " và ",
  undo: "Hoàn tác (Ctrl+Z)",
  redo: "Làm lại (Ctrl+Y)",
  pageDeleted: "Đã xóa trang — Hoàn tác để lấy lại.",
  allReports: "Tất cả báo cáo",
  homeAll: "Tất cả",
  homeMine: "Báo cáo của tôi",
  homeShared: "Được chia sẻ với tôi",
  homeSearch: "Tìm báo cáo…",
  colName: "Tên",
  colOwner: "Người tạo",
  colSharedWith: "Chia sẻ với",
  colUpdated: "Sửa lần cuối",
  you: "Tôi",
  sharedWithYou: "Được chia sẻ với bạn",
  sharedBy: "{{name}} chia sẻ",
  privateOnly: "Riêng tư",
  everyone: "Mọi người",
  everyoneHint: "mọi người xem được dữ liệu {{ds}}",
  nPeople: "{{n}} người",
  homeEmptyMine: "Bạn chưa có báo cáo nào. Bấm Báo cáo mới để tạo.",
  homeEmptyShared: "Chưa có ai chia sẻ báo cáo với bạn.",
  homeEmptySearch: "Không có báo cáo nào khớp.",
  continueDraft: "Làm tiếp chỗ đang dở",
  draftNew: "một báo cáo mới chưa lưu",
  draftChanged: "thay đổi chưa lưu của “{{name}}”",
  continue: "Làm tiếp",
  discardDraft: "Bỏ",
  confirmDiscard: "Bỏ các thay đổi chưa lưu của “{{name}}”?",
  shareTitle: "Chia sẻ “{{name}}”",
  shareSearch: "Thêm người, department hoặc entity…",
  kind_all: "Mọi người",
  kind_team: "Department",
  kind_entity: "Entity",
  oneTeam: "Department",
  oneEntity: "Entity",
  kind_user: "Người",
  sharePrivate: "Riêng tư — chỉ bạn mở được.",
  shareReach: "{{n}} người sẽ thấy báo cáo này.",
  shareCannot: "{{n}} người được chọn ở đây chưa có quyền xem dữ liệu {{ds}}, nên chưa thấy báo cáo cho đến khi được cấp quyền:",
  noAccessTag: "chưa có quyền dữ liệu",
  noAccessHint: "Chưa có quyền xem dữ liệu {{ds}} — chưa thấy báo cáo cho đến khi được cấp.",
  shareNote: "Người được chia sẻ chỉ xem: bộ lọc và slicer chỉ đổi trên màn hình của họ. Chỉ bạn sửa được báo cáo; ai có quyền tạo báo cáo thì lưu được bản sao.",
  makePrivate: "Để riêng tư",
  shareSaved: "Đã lưu chia sẻ",
  shareSaveFirst: "Lưu báo cáo trước rồi mới chia sẻ.",
  removeShare: "Bỏ",
  peopleWithAccess: "Những người có quyền truy cập",
  generalAccess: "Quyền truy cập chung",
  youMark: "(bạn)",
  roleOwner: "Chủ sở hữu",
  roleViewer: "Người xem",
  roleEditor: "Người chỉnh sửa",
  roleHead: "Vai trò",
  transferOwnership: "Chuyển quyền sở hữu",
  transferNoBuild: "{{name}} chưa có quyền dựng báo cáo (Data Explorer) nên không thể làm chủ sở hữu.",
  transferNoData: "{{name}} chưa xem được dữ liệu {{ds}}.",
  transferAsk: "Chuyển quyền sở hữu cho {{name}}?",
  transferHint: "Bạn vẫn ở lại với vai trò người chỉnh sửa. Chỉ chủ sở hữu mới chia sẻ, xóa hoặc chuyển tiếp được.",
  transferGo: "Chuyển",
  transferDone: "{{name}} giờ là chủ sở hữu báo cáo — bạn vẫn là người chỉnh sửa.",
  roleOf: "Quyền",
  removeAccess: "Xóa quyền truy cập",
  genRestricted: "Bị hạn chế",
  genRestrictedHint: "Chỉ những người được thêm ở trên mới mở được bằng đường liên kết",
  genEveryone: "Mọi người xem được dữ liệu {{ds}}",
  genEveryoneHint: "Ai ở Helinox xem được dữ liệu {{ds}} đều mở xem được",
  copyLink: "Sao chép đường liên kết",
  linkCopied: "Đã sao chép đường liên kết",
  shareDone: "Xong",
  noMatch: "Không có kết quả.",
  notFound: "Báo cáo không còn, hoặc chưa được chia sẻ với bạn.",
  deleted: "Đã xóa báo cáo",
  fBackwards: "Ngày kết thúc đang trước ngày bắt đầu.",
  nPerson: "1 người",
  shareReachOne: "1 người sẽ thấy báo cáo này.",
  rel_today: "Hôm nay",
  rel_yesterday: "Hôm qua",
  rel_thisWeek: "Tuần này",
  rel_lastWeek: "Tuần trước",
  rel_thisMonth: "Tháng này (đến hôm nay)",
  rel_lastMonth: "Tháng trước",
  rel_thisQuarter: "Quý này (đến hôm nay)",
  rel_lastQuarter: "Quý trước",
  rel_thisYear: "Năm nay (đến hôm nay)",
  relW_thisWeek: "Tuần này (trọn tuần)",
  relW_thisMonth: "Tháng này (trọn tháng)",
  relW_thisQuarter: "Quý này (trọn quý)",
  relW_thisYear: "Năm nay (trọn năm)",
  rel_lastYear: "Năm trước",
  relLastN_day: "{{n}} ngày gần nhất",
  relLastN_week: "{{n}} tuần gần nhất",
  relLastN_month: "{{n}} tháng gần nhất",
  relLastN_year: "{{n}} năm gần nhất",
  relLast: "Gần nhất",
  relLastN: "Số lượng",
  relUnit: "Đơn vị",
  relUnit_day: "ngày",
  relUnit_week: "tuần",
  relUnit_month: "tháng",
  relUnit_year: "năm",
  relHint: "Lưu theo kỳ, không lưu ngày cố định: báo cáo lưu với \"Tháng này\" sẽ luôn hiện tháng hiện tại mỗi khi mở. \"… này\" tính đến hôm nay.",
  relHintN: "Đếm lùi từ hôm nay, tính cả hôm nay. Tháng và năm là tháng, năm trọn theo lịch: \"12 tháng gần nhất\" là tháng này và 11 tháng trước đó.",
  relBadN: "Nhập một số nguyên từ 1 đến 400.",
  fMode_relative: "Kỳ tương đối",
  fMode_range: "Giữa hai ngày",
  fClearDates: "Xóa ngày",
  sumRel: "{{field}}: {{period}}",
  vt_kpi: "KPI",
  vt_combo: "Đường và cột",
  vt_pie: "Tròn",
  vt_donut: "Vành khuyên",
  w_indicator: "Giá trị",
  w_trend: "Trục xu hướng",
  w_colValues: "Giá trị cột",
  w_lineValues: "Giá trị đường",
  showAs: "Hiện giá trị dưới dạng",
  calc_none: "Giá trị",
  calc_py: "Cùng kỳ năm trước",
  calc_yoy: "Chênh lệch so với năm trước",
  calc_yoy_pct: "Chênh lệch so với năm trước %",
  calc_pm: "Cùng kỳ tháng trước",
  calc_mom: "Chênh lệch so với tháng trước",
  calc_mom_pct: "Chênh lệch so với tháng trước %",
  calc_share: "% trên tổng",
  kpiTitle: "{{value}} so với năm trước",
  kpiNoLy: "Không có số liệu cùng kỳ năm trước",
  kpiVsLy: "so với {{value}} năm trước",
  pieNegatives: "Số âm không được vẽ trong biểu đồ tròn.",
  expandAll: "Mở rộng tất cả",
  collapseAll: "Thu gọn tất cả",
  expand: "Mở rộng",
  collapse: "Thu gọn",
  tab_build: "Dựng",
  tab_format: "Định dạng",
  fmtShowTitle: "Hiện tiêu đề",
  fmtNumbers: "Số",
  fmtUnits: "Đơn vị hiển thị",
  fmtUnits_default: "Theo trường",
  fmtUnits_auto: "Tự động (1.2M)",
  fmtUnits_none: "Không",
  fmtUnits_K: "Nghìn (K)",
  fmtUnits_M: "Triệu (M)",
  fmtUnits_B: "Tỷ (B)",
  fmtDecimals: "Số chữ số thập phân",
  fmtAuto: "Tự động",
  fmtChart: "Biểu đồ",
  fmtLabels: "Nhãn dữ liệu",
  anchored: "Tính đến {{date}}",
  anchoredHint: "Khoảng ngày chọn cho trang hoặc báo cáo này kết thúc ngày {{date}}, nên \"Năm nay\", \"Tuần trước\", \"Tháng này\"… của từng biểu đồ được tính từ ngày đó, không phải từ hôm nay.",
  colAction: "Thao tác",
  open: "Mở",
  slicerPicked: "Đã chọn {{n}}",
  fmtSlicerStyle: "Kiểu",
  fmtSlicer_list: "Danh sách",
  fmtSlicer_dropdown: "Danh sách thả xuống",
  renameValue: "Đổi tên trong biểu đồ này",
  renamedFrom: "{{name}} — đổi tên từ {{field}} trong biểu đồ này",
  fmtLegend: "Chú thích",
  fmtLegend_top: "Trên",
  fmtLegend_bottom: "Dưới",
  fmtLegend_right: "Phải",
  fmtLegend_none: "Ẩn",
  fmtColour: "Màu",
  fmtCond: "Định dạng có điều kiện",
  fmtCondKind: "Ô",
  fmtCond_none: "Không",
  fmtCond_scale: "Thang màu",
  fmtCond_bars: "Thanh dữ liệu",
  fmtCondHint_scale: "Mỗi ô được tô theo độ lớn, càng lớn càng đậm; số âm tô đỏ. Dòng tổng giữ nguyên.",
  fmtCondHint_bars: "Mỗi ô có một thanh dài theo tỷ lệ so với số lớn nhất trong bảng. Dòng tổng giữ nguyên.",
  fmtReset: "Về định dạng mặc định",
};

const zh = {
  // operations datasets — Samples, Project SKUs, Tickets (Max 31/10)
  ds_samples: "样品",
  ds_skus: "项目 SKU",
  ds_tickets: "工单",
  group_status: "状态",
  group_people: "负责人",
  group_checks: "缺失信息",
  sw_allRounds: "所有轮次（不仅是当前轮次）",
  f_request_date: "申请日期",
  f_due_date: "开发截止日 (Development Due)",
  f_sent_date: "寄出日期",
  f_state: "进度",
  f_late_state: "准时 / 延迟",
  f_due_bucket: "何时到期",
  f_rm_state: "原材料 (RM)",
  f_outcome: "结果",
  f_rework_reason: "返工原因",
  f_round: "轮次",
  f_developer: "开发负责人",
  f_designer: "设计师",
  f_location: "制作地点",
  f_team: "Sales OP 团队",
  f_project: "项目",
  f_sample: "样品",
  f_season: "季度",
  f_rounds: "轮次数",
  f_samples_count: "样品数",
  f_in_work: "制作中",
  f_waiting_comment: "等待评语",
  f_overdue_not_sent: "逾期未寄出",
  f_sent_late: "延迟寄出",
  f_sent_on_time: "准时寄出",
  f_days_late: "延迟天数",
  f_make_days: "制作天数",
  f_round_cycle_days: "轮次周期（天）",
  f_exf_date: "EXF 日期",
  f_created_date: "创建日期",
  f_status: "状态",
  f_sku_approval: "SKU 审批",
  f_project_approval: "项目审批",
  f_exf_bucket: "EXF 时间",
  f_order_kind: "新单 / 返单",
  f_has_remark: "备注",
  f_chk_exf: "EXF 日期",
  f_chk_developer: "开发负责人",
  f_chk_designer: "设计师",
  f_chk_sales_rep: "销售代表",
  f_chk_season: "季度",
  f_chk_launch: "上市月份",
  f_owner: "项目负责人",
  f_sales_rep: "销售代表",
  f_vendor: "供应商",
  f_project_category: "项目类别",
  f_launch_month: "上市月份",
  f_project_count: "项目数",
  f_skus_missing_info: "信息缺失的 SKU",
  f_missing_fields: "缺失项数",
  f_closed_date: "关闭日期",
  f_team_reply: "团队回复",
  f_due_state: "到期状态",
  f_ticket_code: "工单代码",
  f_receiving_team: "接收团队",
  f_assignee: "负责人",
  f_requester: "申请人",
  f_ticket: "工单",
  f_ticket_count: "工单数",
  f_open_tickets: "未关闭工单",
  f_overdue_tickets: "逾期工单",
  f_days_to_close: "关闭用时（天）",
  f_days_open: "已开启天数",
  title: '数据探索',
  asOf: '数据截至 {{date}}',
  dataset: '数据集',
  ds_sales: '销售',
  ds_inventory: '库存',
  ds_marketing: "市场营销",
  group_channel: "渠道",
  f_mkt_date: "日期",
  f_market: "市场",
  f_mkt_channel: "渠道类型",
  f_mkt_platform: "平台",
  f_mkt_account: "账户",
  f_campaign: "广告系列",
  f_mkt_currency: "账户币种",
  f_ad_spend: "广告花费",
  f_impressions: "展示次数",
  f_ad_clicks: "点击次数",
  f_ctr: "点击率",
  f_cpc: "单次点击成本",
  f_cpm: "千次展示成本",
  f_attributed_revenue: "广告自报收入",
  f_attributed_orders: "广告自报购买",
  f_roas: "ROAS（平台自报）",
  f_email_revenue: "邮件收入（Klaviyo）",
  f_email_orders: "邮件订单（Klaviyo）",
  f_sessions: "网站会话（GA4）",
  f_web_revenue: "网站收入（GA4）",
  f_web_orders: "网站订单（GA4）",
  f_web_conversion: "网站转化率",
  f_store_sales: "店铺销售额（Shopify）",
  f_store_orders: "店铺订单（Shopify）",
  f_mer: "店铺销售额 ÷ 广告花费",
  f_spend_share: "广告花费 ÷ 店铺销售额",
  ds_pole_position: "支架当前状况",
  f_snap_date: "快照日期",
  f_base_month: "已结账月份",
  f_line_kind: "行类型",
  f_po_due: "未入库订单到期",
  f_pole_family: "支架系列",
  f_end_qty: "结账月末库存",
  f_received_qty: "此后入库",
  f_to_group_qty: "此后转其他法人",
  f_sold_qty: "此后销售",
  f_other_qty: "其他变动",
  f_now_qty: "今日库存",
  f_po_total_qty: "未入库订单（合计）",
  f_po_qty: "未入库订单数量",
  f_avg_month_sales: "月均销售（3个月）",
  f_months_of_stock: "库存月数",
  f_months_with_po: "库存月数（含订单）",
  group_stock: '库存',
  f_snapshot: '快照日期',
  f_day_kind: '日期类型（周五 = 周）',
  f_latest_day: '最新日期',
  f_ageing: '库龄',
  f_stock_kind: '在库 / 在途',
  f_line_status: '产品线状态',
  f_inbound_year: '入库年份',
  f_brand: '品牌',
  f_goods_type: '货品类型',
  f_inv_category: '类别',
  f_inv_subcategory: '子类别',
  f_family: '系列',
  f_size_class: '尺寸分类',
  f_consignment: '自有 / 寄售',
  f_product: '产品',
  f_color: '颜色',
  f_stock_amount: '在库金额（USD）',
  f_stock_qty: '在库数量',
  f_transit_amount: '在途金额（USD）',
  f_transit_qty: '在途数量',
  f_over1y_share: '超过 1 年金额占比',
  f_avg_age: '平均库龄（天）',
  sw_allDays: '所有快照日期',
  fieldSearch: '查找字段…',
  group_time: '时间',
  group_product: '产品',
  group_org: '法人与渠道',
  group_geo: '地区',
  group_measures: '值',
  f_date: '日期',
  f_line: '产品线',
  f_category: '产品类别',
  f_type: '产品类型',
  f_subtype: '产品子类型',
  f_frame_model: '框架型号',
  f_frame_color: '框架颜色',
  f_sku: 'SKU',
  f_entity_group: '法人组',
  f_entity: '法人',
  f_channel: '渠道',
  f_channel2: '子渠道',
  f_channel3: '渠道明细',
  f_customer: '客户',
  f_region: '区域',
  f_subregion: '子区域',
  f_country: '国家',
  f_revenue: '销售额',
  f_quantity: '数量',
  f_avg_price: '平均单价',
  f_sku_count: 'SKU 数',
  f_customer_count: '客户数',
  f_lines: '交易行数',
  f_target: '目标',
  f_achievement: '达成率 %',
  f_vs_target: '与目标差额',
  vt_map: '地图',
  w_location: '位置',
  w_mapColor: '着色依据',
  mapNeedsGeo: '地图需要国家、子区域或区域。请将其中一个放入“位置”。',
  mapNone: '无数值',
  mapUnplaced: '不在地图上（{{n}}）：{{names}}',
  fmtTopN: '显示',
  fmtTopN_all: '所有行',
  fmtTopN_n: '前 {{n}}',
  topNote: '按第一个值，{{total}} 项中的前 {{n}} 项。',
  topNoteTable: '按第一个值，{{total}} 项中的前 {{n}} 项；合计行包含全部。',
  targetBlocked: '此处无目标：目标只按日期、法人组、法人和渠道设定，不按 {{fields}}。',
  targetBlockedShort: '无按 {{fields}} 的目标',
  relWholeN: '仅完整期间',
  relWholeOpt: '到期间结束（目标按整个期间）',
  relWholeNOpt: '仅完整期间（不含当前期间）',
  relHintWhole: '从期间开始到期间结束。销售截至最新数据日，目标计到期间结束——与 Sales Report 将本月累计与整月目标对比的方式相同。',
  relHintNWhole: '当前期间之前的完整期间：“最近 5 周”是本周之前的 5 周（周一至周日）。',
  g_year: '年',
  g_quarter: '季度',
  g_month: '月',
  g_week: '周',
  g_day: '日',
  a_sum: '合计',
  a_avg: '平均',
  a_min: '最小',
  a_max: '最大',
  dropHere: '将字段拖到此处',
  remove: '移除',
  sw_includeInternal: '关联公司间销售',
  sw_includeOversea: 'Oversea 销售',
  currency: '币种',
  chartTop: '图表显示 {{total}} 行中的前 {{n}} 行。',
  other: '其他',
  total: '合计',
  loading: '处理中…',
  truncated: '仅显示最大的 {{n}} 组。添加筛选可查看其余部分。',
  tooManyCols: '显示 {{total}} 列中最大的 {{n}} 列。对列字段设置筛选可选择其他列。',
  moreRows: '再显示 {{n}} 行',
  drillUp: '上一级',
  drillInto: '向下钻取到 {{value}}',
  fInclude: '包含',
  fExclude: '排除',
  fContains: '含有文字',
  fSearch: '搜索值…',
  fSelectShown: '全选当前显示',
  fClear: '清除选择',
  fApply: '应用',
  fCancel: '取消',
  fMore: '仅列出前 500 个值。请搜索查找其他值。',
  fNone: '没有匹配的值。',
  fFrom: '从',
  fTo: '到',
  fAll: '全部日期',
  fSelected: '已选 {{n}} 个',
  containsText: '值中包含的文字',
  sumIn: '{{field}}：{{values}}',
  sumNotIn: '{{field}}：不含 {{values}}',
  sumMore: '另 {{n}} 个',
  sumContains: '{{field}}含有“{{text}}”',
  sumRange: '{{field}}：{{from}} – {{to}}',
  sumFrom: '{{field}}：自 {{from}}',
  sumTo: '{{field}}：至 {{to}}',
  sumAll: '{{field}}：全部',
  save: '保存',
  saveAs: '另存为…',
  rename: '重命名',
  share: "共享",
  delete: '删除',
  unsaved: '有未保存的更改',
  saved: '已保存',
  copyLink: '复制链接',
  linkCopied: '链接已复制',
  by: '创建者：{{name}}',
  confirmDelete: '删除“{{name}}”？此操作无法撤销。',
  sharedBadge: '已共享',
  errLoad: '无法加载数据探索。',
  errNoDatasets: '您还没有可用的数据集。请向管理员申请权限。',
  reports: "报表",
  myReports: "我的报表",
  sharedReports: "与我共享",
  noReports: "还没有保存的报表。",
  newReport: "新报表",
  untitled: "未命名报表",
  reportName: "报表名称",
  editMode: "编辑",
  readMode: "阅读视图",
  refresh: "重新读取数据",
  clearSelection: "清除选择",
  emptyVisual: "在“数据”窗格中选择字段来构建此视觉对象。",
  emptyPage: "此页为空。在“可视化”窗格中选择类型，或在“数据”窗格中勾选字段。",
  emptyPageRead: "此页为空。",
  tooManyVisuals: "每页最多 {{n}} 个视觉对象。",
  drillMode: "向下钻取：单击进入下一级",
  nextLevel: "转到下一级",
  moreOptions: "更多选项",
  showTable: "以表格显示",
  showVisual: "以视觉对象显示",
  focus: "聚焦模式",
  backToReport: "返回报表",
  exportData: "导出数据 (Excel)",
  duplicate: "复制",
  removeVisual: "删除",
  presets: "快速范围…",
  slicerAll: "全部",
  dataPane: "数据",
  visPane: "可视化",
  filtersPane: "筛选器",
  newVisual: "添加",
  visHint: "选择一种类型来添加视觉对象，或单击页面上的视觉对象来更改它。",
  vt_card: "卡片",
  vt_table: "表",
  vt_matrix: "矩阵",
  vt_column: "柱形图",
  vt_stacked: "堆积柱形图",
  vt_bar: "条形图",
  vt_line: "折线图",
  vt_area: "面积图",
  vt_slicer: "切片器",
  w_fields: "字段",
  w_columns: "列",
  w_rows: "行",
  w_cols: "列",
  w_values: "值",
  w_xaxis: "X 轴",
  w_legend: "图例",
  w_yaxis: "Y 轴",
  w_yaxisCat: "Y 轴",
  w_xaxisVal: "X 轴",
  w_field: "字段",
  vTitle: "标题",
  grain: "日期级别",
  dateRange: "日期范围",
  aggregation: "汇总方式",
  filtersVisual: "此视觉对象上的筛选器",
  filtersPage: "此页上的筛选器",
  filtersAll: "所有页上的筛选器",
  addFilter: "添加筛选器",
  pages: "页",
  pageN: "第 {{n}} 页",
  addPage: "新页",
  pageOptions: "页面选项",
  pageTabHint: "双击重命名",
  renamePage: "重命名页",
  duplicatePage: "复制页",
  moveLeft: "左移",
  moveRight: "右移",
  deletePage: "删除页",
  confirmDeletePage: "删除“{{name}}”页及其视觉对象？",
  confirmNewDataset: "选择其他数据集会开始一个新报表。当前报表若未先保存将会丢失。继续吗？",
  titleBy: "按{{dims}}的{{values}}",
  titleAnd: "、",
  undo: "撤销 (Ctrl+Z)",
  redo: "重做 (Ctrl+Y)",
  pageDeleted: "已删除该页 — 撤销可恢复。",
  allReports: "全部报表",
  homeAll: "全部",
  homeMine: "我的报表",
  homeShared: "与我共享",
  homeSearch: "查找报表…",
  colName: "名称",
  colOwner: "所有者",
  colSharedWith: "共享对象",
  colUpdated: "最后修改",
  you: "我",
  sharedWithYou: "与您共享",
  sharedBy: "由 {{name}} 共享",
  privateOnly: "私有",
  everyone: "所有人",
  everyoneHint: "所有能查看{{ds}}数据的人",
  nPeople: "{{n}} 人",
  homeEmptyMine: "您还没有报表。点击“新建报表”来创建。",
  homeEmptyShared: "还没有人与您共享报表。",
  homeEmptySearch: "没有匹配的报表。",
  continueDraft: "继续上次的工作",
  draftNew: "尚未保存的新报表",
  draftChanged: "“{{name}}”的未保存更改",
  continue: "继续",
  discardDraft: "放弃",
  confirmDiscard: "放弃“{{name}}”的未保存更改？",
  shareTitle: "共享“{{name}}”",
  shareSearch: "添加人员、部门或法人…",
  kind_all: "所有人",
  kind_team: "部门",
  kind_entity: "法人",
  oneTeam: "部门",
  oneEntity: "法人",
  kind_user: "人员",
  sharePrivate: "私有 — 只有您可以打开。",
  shareReach: "将有 {{n}} 人看到。",
  shareCannot: "此处指定的 {{n}} 人尚无{{ds}}数据权限，获得权限前看不到该报表：",
  noAccessTag: "无数据权限",
  noAccessHint: "尚无{{ds}}数据权限 — 获得权限前看不到该报表。",
  shareNote: "被共享者只能查看：筛选器和切片器只改变他们自己的画面。只有您能修改报表；能创建报表的人可以保存副本。",
  makePrivate: "设为私有",
  shareSaved: "共享已保存",
  shareSaveFirst: "请先保存报表，再共享。",
  removeShare: "移除",
  peopleWithAccess: "有权访问的用户",
  generalAccess: "一般访问权限",
  youMark: "（您）",
  roleOwner: "所有者",
  roleViewer: "查看者",
  roleEditor: "编辑者",
  roleHead: "角色",
  transferOwnership: "转移所有权",
  transferNoBuild: "{{name}} 无法制作报告（没有 Data Explorer 权限），因此不能成为所有者。",
  transferNoData: "{{name}} 还看不到 {{ds}} 数据。",
  transferAsk: "将 {{name}} 设为所有者？",
  transferHint: "您将保留编辑者身份。只有新所有者可以共享、删除或再次转移。",
  transferGo: "转移",
  transferDone: "现在 {{name}} 是报告的所有者 — 您保留编辑者身份。",
  roleOf: "权限",
  removeAccess: "移除访问权限",
  genRestricted: "受限",
  genRestrictedHint: "只有上面添加的用户才能通过链接打开",
  genEveryone: "所有可查看 {{ds}} 数据的人",
  genEveryoneHint: "Helinox 中凡可查看 {{ds}} 数据的人都可以打开阅读",
  copyLink: "复制链接",
  linkCopied: "已复制链接",
  shareDone: "完成",
  noMatch: "没有匹配项。",
  notFound: "该报表已不存在，或未与您共享。",
  deleted: "报表已删除",
  fBackwards: "结束日期早于开始日期。",
  nPerson: "1 人",
  shareReachOne: "将有 1 人看到。",
  rel_today: "今天",
  rel_yesterday: "昨天",
  rel_thisWeek: "本周",
  rel_lastWeek: "上周",
  rel_thisMonth: "本月 (截至今天)",
  rel_lastMonth: "上月",
  rel_thisQuarter: "本季度 (截至今天)",
  rel_lastQuarter: "上季度",
  rel_thisYear: "今年 (截至今天)",
  relW_thisWeek: "本周 (整周)",
  relW_thisMonth: "本月 (整月)",
  relW_thisQuarter: "本季度 (整季)",
  relW_thisYear: "今年 (全年)",
  rel_lastYear: "去年",
  relLastN_day: "最近 {{n}} 天",
  relLastN_week: "最近 {{n}} 周",
  relLastN_month: "最近 {{n}} 个月",
  relLastN_year: "最近 {{n}} 年",
  relLast: "最近",
  relLastN: "数量",
  relUnit: "单位",
  relUnit_day: "天",
  relUnit_week: "周",
  relUnit_month: "个月",
  relUnit_year: "年",
  relHint: "按期间保存，而不是固定日期：以“本月”保存的报表每次打开都显示当月。“本…”截至今天。",
  relHintN: "从今天往回数，包括今天。月和年按日历计算：“最近 12 个月”是本月及之前的 11 个月。",
  relBadN: "请输入 1 到 400 之间的整数。",
  fMode_relative: "相对期间",
  fMode_range: "日期之间",
  fClearDates: "清除日期",
  sumRel: "{{field}}：{{period}}",
  vt_kpi: "KPI",
  vt_combo: "折线和柱形",
  vt_pie: "饼图",
  vt_donut: "环形图",
  w_indicator: "值",
  w_trend: "趋势轴",
  w_colValues: "柱形值",
  w_lineValues: "折线值",
  showAs: "值显示为",
  calc_none: "值",
  calc_py: "去年同期",
  calc_yoy: "同比变化",
  calc_yoy_pct: "同比变化 %",
  calc_pm: "上月同期",
  calc_mom: "环比变化",
  calc_mom_pct: "环比变化 %",
  calc_share: "占总计 %",
  kpiTitle: "{{value}} 同比",
  kpiNoLy: "去年同期没有数据",
  kpiVsLy: "去年为 {{value}}",
  pieNegatives: "负数不计入饼图。",
  expandAll: "全部展开",
  collapseAll: "全部折叠",
  expand: "展开",
  collapse: "折叠",
  tab_build: "构建",
  tab_format: "格式",
  fmtShowTitle: "显示标题",
  fmtNumbers: "数字",
  fmtUnits: "显示单位",
  fmtUnits_default: "按字段",
  fmtUnits_auto: "自动 (1.2M)",
  fmtUnits_none: "无",
  fmtUnits_K: "千 (K)",
  fmtUnits_M: "百万 (M)",
  fmtUnits_B: "十亿 (B)",
  fmtDecimals: "小数位数",
  fmtAuto: "自动",
  fmtChart: "图表",
  fmtLabels: "数据标签",
  anchored: "截至 {{date}}",
  anchoredHint: "为此页面或报表选择的日期范围结束于 {{date}}，因此各视觉对象的“今年”“上周”“本月”…均从该日起算，而非从今天起算。",
  colAction: "操作",
  open: "打开",
  slicerPicked: "已选 {{n}} 项",
  fmtSlicerStyle: "样式",
  fmtSlicer_list: "列表",
  fmtSlicer_dropdown: "下拉",
  renameValue: "在此视觉对象中重命名",
  renamedFrom: "{{name}} — 在此视觉对象中由 {{field}} 重命名",
  fmtLegend: "图例",
  fmtLegend_top: "上",
  fmtLegend_bottom: "下",
  fmtLegend_right: "右",
  fmtLegend_none: "隐藏",
  fmtColour: "颜色",
  fmtCond: "条件格式",
  fmtCondKind: "单元格",
  fmtCond_none: "无",
  fmtCond_scale: "色阶",
  fmtCond_bars: "数据条",
  fmtCondHint_scale: "每个单元格按大小着色，越大越深；负数为红色。合计保持不变。",
  fmtCondHint_bars: "每个单元格显示一条长度按表中最大值比例的数据条。合计保持不变。",
  fmtReset: "恢复默认格式",
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "ds_samples": "Échantillons",
  "ds_skus": "SKUs de projet",
  "ds_tickets": "Tickets",
  "group_status": "Statut",
  "group_people": "Personnes",
  "group_checks": "Informations manquantes",
  "sw_allRounds": "Tous les tours (pas seulement le tour en cours)",
  "f_request_date": "Date de demande",
  "f_due_date": "Échéance de développement",
  "f_sent_date": "Date d'envoi",
  "f_state": "État",
  "f_late_state": "Dans les temps / en retard",
  "f_due_bucket": "Échéance",
  "f_rm_state": "Matière (RM)",
  "f_outcome": "Résultat",
  "f_rework_reason": "Motif de reprise",
  "f_round": "Tour",
  "f_developer": "Développeur",
  "f_designer": "Designer",
  "f_location": "Fabriqué à",
  "f_team": "Équipe Sales OP",
  "f_project": "Projet",
  "f_sample": "Échantillon",
  "f_season": "Saison",
  "f_rounds": "Tours",
  "f_samples_count": "Échantillons",
  "f_in_work": "En cours",
  "f_waiting_comment": "En attente de commentaire",
  "f_overdue_not_sent": "En retard, non envoyé",
  "f_sent_late": "Envoyé en retard",
  "f_sent_on_time": "Envoyé dans les temps",
  "f_days_late": "Jours de retard",
  "f_make_days": "Jours de fabrication",
  "f_round_cycle_days": "Cycle du tour (jours)",
  "f_exf_date": "Date EXF",
  "f_created_date": "Créé le",
  "f_status": "Statut",
  "f_sku_approval": "Approbation du SKU",
  "f_project_approval": "Approbation du projet",
  "f_exf_bucket": "EXF quand",
  "f_order_kind": "Commande nouvelle / réassort",
  "f_has_remark": "Remarque",
  "f_chk_exf": "Date EXF",
  "f_chk_developer": "Développeur",
  "f_chk_designer": "Designer",
  "f_chk_sales_rep": "Commercial",
  "f_chk_season": "Saison",
  "f_chk_launch": "Mois de lancement",
  "f_owner": "Responsable du projet",
  "f_sales_rep": "Commercial",
  "f_vendor": "Fournisseur",
  "f_project_category": "Catégorie de projet",
  "f_launch_month": "Mois de lancement",
  "f_project_count": "Projets",
  "f_skus_missing_info": "SKUs avec informations manquantes",
  "f_missing_fields": "Champs manquants",
  "f_closed_date": "Clôturé le",
  "f_team_reply": "Réponse de l'équipe",
  "f_due_state": "État de l'échéance",
  "f_ticket_code": "Code du ticket",
  "f_receiving_team": "Équipe destinataire",
  "f_assignee": "Assigné à",
  "f_requester": "Demandeur",
  "f_ticket": "Ticket",
  "f_ticket_count": "Tickets",
  "f_open_tickets": "Tickets ouverts",
  "f_overdue_tickets": "Tickets en retard",
  "f_days_to_close": "Jours avant clôture",
  "f_days_open": "Jours d'ouverture",
  "title": "Explorateur de données",
  "asOf": "Données au {{date}}",
  "dataset": "Jeu de données",
  "ds_sales": "Ventes",
  "ds_inventory": "Stock",
  "ds_marketing": "Marketing",
  "group_channel": "Canal",
  "f_mkt_date": "Jour",
  "f_market": "Marché",
  "f_mkt_channel": "Type de canal",
  "f_mkt_platform": "Plateforme",
  "f_mkt_account": "Compte",
  "f_campaign": "Campagne",
  "f_mkt_currency": "Devise du compte",
  "f_ad_spend": "Dépenses publicitaires",
  "f_impressions": "Impressions",
  "f_ad_clicks": "Clics",
  "f_ctr": "CTR",
  "f_cpc": "Coût par clic",
  "f_cpm": "Coût pour 1 000 impressions",
  "f_attributed_revenue": "Chiffre d'affaires revendiqué par les pubs",
  "f_attributed_orders": "Achats revendiqués par les pubs",
  "f_roas": "ROAS (revendiqué)",
  "f_email_revenue": "CA e-mail (Klaviyo)",
  "f_email_orders": "Commandes e-mail (Klaviyo)",
  "f_sessions": "Sessions web (GA4)",
  "f_web_revenue": "CA web (GA4)",
  "f_web_orders": "Commandes web (GA4)",
  "f_web_conversion": "Taux de conversion web",
  "f_store_sales": "Ventes boutique (Shopify)",
  "f_store_orders": "Commandes boutique (Shopify)",
  "f_mer": "Ventes boutique ÷ dépenses pub",
  "f_spend_share": "Dépenses pub ÷ ventes boutique",
  "ds_pole_position": "Position des arceaux",
  "f_snap_date": "Jour du cliché",
  "f_base_month": "Mois clôturé",
  "f_line_kind": "Type de ligne",
  "f_po_due": "Échéance du PO ouvert",
  "f_pole_family": "Famille de cadres",
  "f_end_qty": "Stock en fin de mois clôturé",
  "f_received_qty": "Reçu depuis",
  "f_to_group_qty": "Vers d'autres entités depuis",
  "f_sold_qty": "Vendu depuis",
  "f_other_qty": "Autres mouvements",
  "f_now_qty": "Stock aujourd'hui",
  "f_po_total_qty": "PO ouverts (total)",
  "f_po_qty": "Qté de PO ouverts",
  "f_avg_month_sales": "Ventes mensuelles moy. (3 mois)",
  "f_months_of_stock": "Mois de stock",
  "f_months_with_po": "Mois de stock, PO ouverts inclus",
  "group_stock": "Stock",
  "f_snapshot": "Jour du cliché",
  "f_day_kind": "Type de jour (vendredi = semaine)",
  "f_latest_day": "Dernier jour",
  "f_ageing": "Ancienneté",
  "f_stock_kind": "En stock / en transit",
  "f_line_status": "Statut de la ligne",
  "f_inbound_year": "Année d'entrée",
  "f_brand": "Marque",
  "f_goods_type": "Type de marchandise",
  "f_inv_category": "Catégorie",
  "f_inv_subcategory": "Sous-catégorie",
  "f_family": "Famille",
  "f_size_class": "Classe de taille",
  "f_consignment": "Propre / consignation",
  "f_product": "Produit",
  "f_color": "Couleur",
  "f_stock_amount": "Montant en stock (USD)",
  "f_stock_qty": "Qté en stock",
  "f_transit_amount": "Montant en transit (USD)",
  "f_transit_qty": "Qté en transit",
  "f_over1y_share": "Plus d'un an, % du montant",
  "f_avg_age": "Ancienneté moyenne (jours)",
  "sw_allDays": "Tous les jours pris",
  "fieldSearch": "Trouver un champ…",
  "group_time": "Temps",
  "group_product": "Produit",
  "group_org": "Entité et canal",
  "group_geo": "Géographie",
  "group_measures": "Valeurs",
  "f_date": "Date",
  "f_line": "Ligne",
  "f_category": "Catégorie de produit",
  "f_type": "Type de produit",
  "f_subtype": "Sous-type de produit",
  "f_frame_model": "Modèle de cadre",
  "f_frame_color": "Couleur du cadre",
  "f_sku": "SKU",
  "f_entity_group": "Groupe d'entités",
  "f_entity": "Entité",
  "f_channel": "Canal",
  "f_channel2": "Sous-canal",
  "f_channel3": "Détail du canal",
  "f_customer": "Client",
  "f_region": "Région",
  "f_subregion": "Sous-région",
  "f_country": "Pays",
  "f_revenue": "Chiffre d'affaires",
  "f_quantity": "Quantité",
  "f_avg_price": "Prix unitaire moyen",
  "f_sku_count": "Nombre de SKUs",
  "f_customer_count": "Nombre de clients",
  "f_lines": "Lignes de transaction",
  "f_target": "Objectif",
  "f_achievement": "Réalisation %",
  "f_vs_target": "vs objectif",
  "vt_map": "Carte",
  "w_location": "Lieu",
  "w_mapColor": "Couleur selon",
  "mapNeedsGeo": "Une carte place un Pays, une Sous-région ou une Région. Placez l'un d'eux dans Lieu.",
  "mapNone": "Aucune valeur",
  "mapUnplaced": "Hors carte ({{n}}) : {{names}}",
  "fmtTopN": "Afficher",
  "fmtTopN_all": "Toutes les lignes",
  "fmtTopN_n": "Top {{n}}",
  "topNote": "Top {{n}} sur {{total}} selon la première valeur.",
  "topNoteTable": "Top {{n}} sur {{total}} selon la première valeur ; la ligne de total les compte toutes.",
  "targetBlocked": "Pas d'objectif ici : l'objectif est défini uniquement par date, groupe d'entités, entité et canal, et non par {{fields}}.",
  "targetBlockedShort": "Pas d'objectif par {{fields}}",
  "relWholeN": "périodes complètes uniquement",
  "relWholeOpt": "Jusqu'à la fin de la période (l'objectif est celui de la période entière)",
  "relWholeNOpt": "Périodes complètes uniquement (la période en cours est exclue)",
  "relHintWhole": "Du début de la période à sa fin. Les ventes s'arrêtent au dernier jour chargé ; un objectif court jusqu'à la fin, comme le Sales Report compare un mois à ce jour au mois entier.",
  "relHintNWhole": "Périodes entières précédant la période en cours : « 5 dernières semaines » désigne les cinq semaines avant celle-ci, du lundi au dimanche.",
  "g_year": "Année",
  "g_quarter": "Trimestre",
  "g_month": "Mois",
  "g_week": "Semaine",
  "g_day": "Jour",
  "a_sum": "Somme",
  "a_avg": "Moyenne",
  "a_min": "Min",
  "a_max": "Max",
  "dropHere": "Faites glisser un champ ici",
  "remove": "Retirer",
  "sw_includeInternal": "Ventes intra-groupe",
  "sw_includeOversea": "Ventes à l'étranger",
  "currency": "Devise",
  "chartTop": "Le graphique affiche les {{n}} premières lignes sur {{total}}.",
  "other": "Autres",
  "total": "Total",
  "loading": "Traitement en cours…",
  "truncated": "Seuls les {{n}} plus grands groupes sont affichés. Ajoutez un filtre pour voir les autres.",
  "tooManyCols": "Affichage des {{n}} plus grandes colonnes sur {{total}}. Filtrez le champ de colonne pour en choisir d'autres.",
  "moreRows": "Afficher {{n}} lignes de plus",
  "drillUp": "Remonter d'un niveau",
  "drillInto": "Explorer en détail {{value}}",
  "fInclude": "Inclure",
  "fExclude": "Exclure",
  "fContains": "Contient",
  "fSearch": "Rechercher des valeurs…",
  "fSelectShown": "Sélectionner l'affichage",
  "fClear": "Effacer",
  "fApply": "Appliquer",
  "fCancel": "Annuler",
  "fMore": "Seules les 500 premières sont listées. Utilisez la recherche pour trouver les autres.",
  "fNone": "Aucun résultat.",
  "fFrom": "Du",
  "fTo": "Au",
  "fAll": "Toutes les dates",
  "fSelected": "{{n}} sélectionné(s)",
  "containsText": "Texte contenu dans la valeur",
  "sumIn": "{{field}} : {{values}}",
  "sumNotIn": "{{field}} : pas {{values}}",
  "sumMore": "+{{n}} de plus",
  "sumContains": "{{field}} contient « {{text}} »",
  "sumRange": "{{field}} : {{from}} – {{to}}",
  "sumFrom": "{{field}} : à partir du {{from}}",
  "sumTo": "{{field}} : jusqu’au {{to}}",
  "sumAll": "{{field}} : tout",
  "save": "Enregistrer",
  "saveAs": "Enregistrer sous…",
  "rename": "Renommer",
  "share": "Partager",
  "delete": "Supprimer",
  "unsaved": "Modifications non enregistrées",
  "saved": "Enregistré",
  "copyLink": "Copier le lien",
  "linkCopied": "Lien copié",
  "by": "par {{name}}",
  "confirmDelete": "Supprimer « {{name}} » ? Cette action est irréversible.",
  "sharedBadge": "Partagé",
  "errLoad": "Impossible de charger le Data Explorer.",
  "errNoDatasets": "Aucun jeu de données ne vous est encore ouvert. Demandez l’accès à un administrateur.",
  "reports": "Rapports",
  "myReports": "Mes rapports",
  "sharedReports": "Partagés avec moi",
  "noReports": "Aucun rapport enregistré pour le moment.",
  "newReport": "Nouveau rapport",
  "untitled": "Rapport sans titre",
  "reportName": "Nom du rapport",
  "editMode": "Modifier",
  "readMode": "Mode lecture",
  "refresh": "Recharger les données",
  "clearSelection": "Effacer la sélection",
  "emptyVisual": "Choisissez des champs dans le volet Données pour construire ce visuel.",
  "emptyPage": "Cette page est vide. Choisissez un type dans le volet Visualisations ou cochez un champ dans le volet Données.",
  "emptyPageRead": "Cette page est vide.",
  "tooManyVisuals": "Une page contient au maximum {{n}} visuels.",
  "drillMode": "Exploration : un clic descend d’un niveau",
  "nextLevel": "Passer au niveau suivant",
  "moreOptions": "Plus d’options",
  "showTable": "Afficher sous forme de tableau",
  "showVisual": "Afficher le visuel",
  "focus": "Mode focus",
  "backToReport": "Retour au rapport",
  "exportData": "Exporter les données (Excel)",
  "duplicate": "Dupliquer",
  "removeVisual": "Retirer",
  "presets": "Période rapide…",
  "slicerAll": "Tout",
  "dataPane": "Données",
  "visPane": "Visualisations",
  "filtersPane": "Filtres",
  "newVisual": "Ajouter",
  "visHint": "Choisissez un type pour ajouter un visuel, ou cliquez sur un visuel de la page pour le modifier.",
  "vt_card": "Carte",
  "vt_table": "Tableau",
  "vt_matrix": "Matrice",
  "vt_column": "Histogramme",
  "vt_stacked": "Histogramme empilé",
  "vt_bar": "Graphique à barres",
  "vt_line": "Graphique en courbes",
  "vt_area": "Graphique en aires",
  "vt_slicer": "Segment",
  "w_fields": "Champs",
  "w_columns": "Colonnes",
  "w_rows": "Lignes",
  "w_cols": "Colonnes",
  "w_values": "Valeurs",
  "w_xaxis": "Axe X",
  "w_legend": "Légende",
  "w_yaxis": "Axe Y",
  "w_yaxisCat": "Axe Y",
  "w_xaxisVal": "Axe X",
  "w_field": "Champ",
  "vTitle": "Titre",
  "grain": "Niveau de date",
  "dateRange": "Période",
  "aggregation": "Agrégation",
  "filtersVisual": "Filtres sur ce visuel",
  "filtersPage": "Filtres sur cette page",
  "filtersAll": "Filtres sur toutes les pages",
  "addFilter": "Ajouter un filtre",
  "pages": "Pages",
  "pageN": "Page {{n}}",
  "addPage": "Nouvelle page",
  "pageOptions": "Options de la page",
  "pageTabHint": "Double-cliquez pour renommer",
  "renamePage": "Renommer la page",
  "duplicatePage": "Dupliquer la page",
  "moveLeft": "Déplacer vers la gauche",
  "moveRight": "Déplacer vers la droite",
  "deletePage": "Supprimer la page",
  "confirmDeletePage": "Supprimer la page « {{name}} » et ses visuels ?",
  "confirmNewDataset": "Un autre jeu de données lance un nouveau rapport. Le rapport affiché sera perdu si vous ne l’enregistrez pas d’abord. Continuer ?",
  "titleBy": "{{values}} par {{dims}}",
  "titleAnd": " et ",
  "undo": "Annuler (Ctrl+Z)",
  "redo": "Rétablir (Ctrl+Y)",
  "pageDeleted": "Page supprimée — Annuler la rétablit.",
  "allReports": "Tous les rapports",
  "homeAll": "Tous",
  "homeMine": "Mes rapports",
  "homeShared": "Partagés avec moi",
  "homeSearch": "Rechercher un rapport…",
  "colName": "Nom",
  "colOwner": "Propriétaire",
  "colSharedWith": "Partagé avec",
  "colUpdated": "Dernière modification",
  "you": "Vous",
  "sharedWithYou": "Partagé avec vous",
  "sharedBy": "Partagé par {{name}}",
  "privateOnly": "Privé",
  "everyone": "Tout le monde",
  "everyoneHint": "toute personne pouvant voir les données {{ds}}",
  "nPeople": "{{n}} personnes",
  "homeEmptyMine": "Vous n’avez pas encore de rapport. Cliquez sur Nouveau rapport pour en créer un.",
  "homeEmptyShared": "Personne n’a encore partagé de rapport avec vous.",
  "homeEmptySearch": "Aucun rapport ne correspond.",
  "continueDraft": "Reprendre là où vous en étiez",
  "draftNew": "un nouveau rapport non encore enregistré",
  "draftChanged": "modifications non enregistrées de « {{name}} »",
  "continue": "Continuer",
  "discardDraft": "Abandonner",
  "confirmDiscard": "Abandonner les modifications non enregistrées de « {{name}} » ?",
  "shareTitle": "Partager « {{name}} »",
  "shareSearch": "Ajouter des personnes, des départements ou des entités…",
  "kind_all": "Tout le monde",
  "kind_team": "Départements",
  "kind_entity": "Entités",
  "oneTeam": "Département",
  "oneEntity": "Entité",
  "kind_user": "Personnes",
  "sharePrivate": "Privé — vous seul pouvez l’ouvrir.",
  "shareReach": "{{n}} personnes le verront.",
  "shareCannot": "{{n}} personne(s) citée(s) ici ne peuvent pas encore voir les données {{ds}} ; le rapport ne s’affichera pas pour elles tant qu’elles n’y auront pas accès :",
  "noAccessTag": "pas d’accès aux données",
  "noAccessHint": "N’a pas encore l’autorisation d’accéder aux données {{ds}} — ne verra pas le rapport tant qu’elle ne l’aura pas.",
  "shareNote": "Ces personnes l’ouvrent en lecture : les filtres et segments ne modifient que leur propre écran. Vous seul modifiez le rapport ; toute personne qui crée des rapports peut en enregistrer une copie.",
  "makePrivate": "Rendre privé",
  "shareSaved": "Partage enregistré",
  "shareSaveFirst": "Enregistrez d’abord le rapport, puis partagez-le.",
  "removeShare": "Retirer",
  "peopleWithAccess": "Personnes ayant accès",
  "generalAccess": "Accès général",
  "youMark": "(vous)",
  "roleOwner": "Propriétaire",
  "roleViewer": "Lecteur",
  "roleEditor": "Éditeur",
  "roleHead": "Rôle",
  "transferOwnership": "Transférer la propriété",
  "transferNoBuild": "{{name}} ne peut pas créer de rapports (pas d’accès au Data Explorer) et ne pourrait donc pas en être propriétaire.",
  "transferNoData": "{{name}} ne peut pas encore voir les données {{ds}}.",
  "transferAsk": "Faire de {{name}} le propriétaire ?",
  "transferHint": "Vous restez éditeur. Seul le nouveau propriétaire peut le partager, le supprimer ou le transmettre.",
  "transferGo": "Transférer",
  "transferDone": "{{name}} est désormais propriétaire du rapport — vous restez éditeur.",
  "roleOf": "Accès",
  "removeAccess": "Retirer l’accès",
  "genRestricted": "Restreint",
  "genRestrictedHint": "Seules les personnes ajoutées ci-dessus peuvent l’ouvrir avec le lien",
  "genEveryone": "Toute personne pouvant voir les données {{ds}}",
  "genEveryoneHint": "Toute personne chez Helinox pouvant voir les données {{ds}} peut l’ouvrir en lecture",
  "shareDone": "Terminé",
  "noMatch": "Aucun résultat.",
  "notFound": "Ce rapport n’existe plus ou n’est pas partagé avec vous.",
  "deleted": "Rapport supprimé",
  "fBackwards": "La date de fin est antérieure à la date de début.",
  "nPerson": "1 personne",
  "shareReachOne": "1 personne le verra.",
  "rel_today": "Aujourd’hui",
  "rel_yesterday": "Hier",
  "rel_thisWeek": "Cette semaine",
  "rel_lastWeek": "Semaine dernière",
  "rel_thisMonth": "Ce mois (à ce jour)",
  "rel_lastMonth": "Mois dernier",
  "rel_thisQuarter": "Ce trimestre (à ce jour)",
  "rel_lastQuarter": "Trimestre dernier",
  "rel_thisYear": "Cette année (à ce jour)",
  "relW_thisWeek": "Cette semaine (entière)",
  "relW_thisMonth": "Ce mois (entier)",
  "relW_thisQuarter": "Ce trimestre (entier)",
  "relW_thisYear": "Cette année (entière)",
  "rel_lastYear": "Année dernière",
  "relLastN_day": "{{n}} derniers jours",
  "relLastN_week": "{{n}} dernières semaines",
  "relLastN_month": "{{n}} derniers mois",
  "relLastN_year": "{{n}} dernières années",
  "relLast": "Derniers",
  "relLastN": "Combien",
  "relUnit": "Unité",
  "relUnit_day": "jours",
  "relUnit_week": "semaines",
  "relUnit_month": "mois",
  "relUnit_year": "années",
  "relHint": "Conservée comme période et non comme dates : un rapport enregistré avec « Ce mois » affiche le mois en cours à chaque ouverture. « Ce… » va jusqu’à aujourd’hui.",
  "relHintN": "Décompte depuis aujourd’hui, aujourd’hui inclus. Les mois et les années sont des mois et années civils entiers : « 12 derniers mois » correspond au mois en cours et aux 11 précédents.",
  "relBadN": "Saisissez un nombre entier de 1 à 400.",
  "fMode_relative": "Période relative",
  "fMode_range": "Entre deux dates",
  "fClearDates": "Effacer les dates",
  "sumRel": "{{field}} : {{period}}",
  "vt_kpi": "KPI",
  "vt_combo": "Courbes et histogramme",
  "vt_pie": "Secteurs",
  "vt_donut": "Anneau",
  "w_indicator": "Valeur",
  "w_trend": "Axe de tendance",
  "w_colValues": "Valeurs en colonnes",
  "w_lineValues": "Valeurs en courbe",
  "showAs": "Afficher la valeur en",
  "calc_none": "Valeur",
  "calc_py": "Même période l’an dernier",
  "calc_yoy": "Évolution vs l’an dernier",
  "calc_yoy_pct": "Évolution vs l’an dernier %",
  "calc_pm": "Mêmes jours le mois dernier",
  "calc_mom": "Évolution vs le mois dernier",
  "calc_mom_pct": "Évolution vs le mois dernier %",
  "calc_share": "% du total",
  "kpiTitle": "{{value}} vs l’an dernier",
  "kpiNoLy": "Aucun chiffre pour les mêmes jours l’an dernier",
  "kpiVsLy": "vs {{value}} l’an dernier",
  "pieNegatives": "Les chiffres négatifs sont exclus du graphique en secteurs.",
  "expandAll": "Tout développer",
  "collapseAll": "Tout réduire",
  "expand": "Développer",
  "collapse": "Réduire",
  "tab_build": "Construire",
  "tab_format": "Format",
  "fmtShowTitle": "Afficher le titre",
  "fmtNumbers": "Nombres",
  "fmtUnits": "Unités d’affichage",
  "fmtUnits_default": "Comme le champ",
  "fmtUnits_auto": "Auto (1.2M)",
  "fmtUnits_none": "Aucune",
  "fmtUnits_K": "Milliers (K)",
  "fmtUnits_M": "Millions (M)",
  "fmtUnits_B": "Milliards (B)",
  "fmtDecimals": "Décimales",
  "fmtAuto": "Auto",
  "fmtChart": "Graphique",
  "fmtLabels": "Étiquettes de données",
  "anchored": "Périodes au {{date}}",
  "anchoredHint": "Une période choisie pour cette page ou ce rapport se termine le {{date}} ; les options Cette année, Semaine dernière, Ce mois… de chaque visuel sont donc calculées à partir de ce jour et non d’aujourd’hui.",
  "colAction": "Action",
  "open": "Ouvrir",
  "slicerPicked": "{{n}} sélectionné(s)",
  "fmtSlicerStyle": "Style",
  "fmtSlicer_list": "Liste",
  "fmtSlicer_dropdown": "Liste déroulante",
  "renameValue": "Renommer pour ce visuel",
  "renamedFrom": "{{name}} — renommé à partir de {{field}} dans ce visuel",
  "fmtLegend": "Légende",
  "fmtLegend_top": "Haut",
  "fmtLegend_bottom": "Bas",
  "fmtLegend_right": "Droite",
  "fmtLegend_none": "Masquée",
  "fmtColour": "Couleur",
  "fmtCond": "Mise en forme conditionnelle",
  "fmtCondKind": "Cellules",
  "fmtCond_none": "Aucune",
  "fmtCond_scale": "Échelle de couleurs",
  "fmtCond_bars": "Barres de données",
  "fmtCondHint_scale": "Chaque cellule est teintée selon sa valeur, plus foncée pour les valeurs élevées ; un chiffre négatif est teinté en rouge. Les totaux restent neutres.",
  "fmtCondHint_bars": "Chaque cellule porte une barre proportionnelle à sa part du plus grand chiffre du tableau. Les totaux restent neutres.",
  "fmtReset": "Revenir au format par défaut"
};
const ja = {
  "ds_samples": "サンプル",
  "ds_skus": "プロジェクト SKU",
  "ds_tickets": "チケット",
  "group_status": "ステータス",
  "group_people": "担当者",
  "group_checks": "不足情報",
  "sw_allRounds": "すべてのラウンド（現在のラウンドのみではない）",
  "f_request_date": "依頼日",
  "f_due_date": "開発期日",
  "f_sent_date": "送付日",
  "f_state": "状態",
  "f_late_state": "期日内／遅延",
  "f_due_bucket": "期日の区分",
  "f_rm_state": "素材（RM）",
  "f_outcome": "結果",
  "f_rework_reason": "やり直しの理由",
  "f_round": "ラウンド",
  "f_developer": "開発担当",
  "f_designer": "デザイナー",
  "f_location": "製造拠点",
  "f_team": "Sales OP チーム",
  "f_project": "プロジェクト",
  "f_sample": "サンプル",
  "f_season": "シーズン",
  "f_rounds": "ラウンド数",
  "f_samples_count": "サンプル数",
  "f_in_work": "作業中",
  "f_waiting_comment": "コメント待ち",
  "f_overdue_not_sent": "期日超過・未送付",
  "f_sent_late": "遅れて送付",
  "f_sent_on_time": "期日どおりに送付",
  "f_days_late": "遅延日数",
  "f_make_days": "製作日数",
  "f_round_cycle_days": "ラウンドのサイクル（日）",
  "f_exf_date": "EXF 日",
  "f_created_date": "作成日",
  "f_status": "ステータス",
  "f_sku_approval": "SKU 承認",
  "f_project_approval": "プロジェクト承認",
  "f_exf_bucket": "EXF の区分",
  "f_order_kind": "新規／リピート注文",
  "f_has_remark": "備考",
  "f_chk_exf": "EXF 日",
  "f_chk_developer": "開発担当",
  "f_chk_designer": "デザイナー",
  "f_chk_sales_rep": "営業担当",
  "f_chk_season": "シーズン",
  "f_chk_launch": "発売月",
  "f_owner": "プロジェクトオーナー",
  "f_sales_rep": "営業担当",
  "f_vendor": "仕入先",
  "f_project_category": "プロジェクトカテゴリ",
  "f_launch_month": "発売月",
  "f_project_count": "プロジェクト数",
  "f_skus_missing_info": "情報が不足している SKU",
  "f_missing_fields": "不足項目",
  "f_closed_date": "クローズ日",
  "f_team_reply": "チームの返信",
  "f_due_state": "期日の状態",
  "f_ticket_code": "チケットコード",
  "f_receiving_team": "受付チーム",
  "f_assignee": "担当者",
  "f_requester": "依頼者",
  "f_ticket": "チケット",
  "f_ticket_count": "チケット数",
  "f_open_tickets": "未完了のチケット",
  "f_overdue_tickets": "期日超過のチケット",
  "f_days_to_close": "クローズまでの日数",
  "f_days_open": "未完了の日数",
  "title": "データエクスプローラー",
  "asOf": "{{date}} までのデータ",
  "dataset": "データセット",
  "ds_sales": "売上",
  "ds_inventory": "在庫",
  "ds_marketing": "マーケティング",
  "group_channel": "チャネル",
  "f_mkt_date": "日",
  "f_market": "市場",
  "f_mkt_channel": "チャネル種別",
  "f_mkt_platform": "プラットフォーム",
  "f_mkt_account": "アカウント",
  "f_campaign": "キャンペーン",
  "f_mkt_currency": "アカウント通貨",
  "f_ad_spend": "広告費",
  "f_impressions": "インプレッション",
  "f_ad_clicks": "クリック数",
  "f_ctr": "CTR",
  "f_cpc": "クリック単価",
  "f_cpm": "1,000インプレッションあたりのコスト",
  "f_attributed_revenue": "広告側が申告する売上",
  "f_attributed_orders": "広告側が申告する購入数",
  "f_roas": "ROAS（広告側の申告値）",
  "f_email_revenue": "メール売上（Klaviyo）",
  "f_email_orders": "メール注文数（Klaviyo）",
  "f_sessions": "Web セッション（GA4）",
  "f_web_revenue": "Web 売上（GA4）",
  "f_web_orders": "Web 注文数（GA4）",
  "f_web_conversion": "Web コンバージョン率",
  "f_store_sales": "ストア売上（Shopify）",
  "f_store_orders": "ストア注文数（Shopify）",
  "f_mer": "ストア売上 ÷ 広告費",
  "f_spend_share": "広告費 ÷ ストア売上",
  "ds_pole_position": "ポールの在庫状況",
  "f_snap_date": "スナップショット日",
  "f_base_month": "締め月",
  "f_line_kind": "行の種別",
  "f_po_due": "未完了 PO の期日",
  "f_pole_family": "フレームファミリー",
  "f_end_qty": "締め月末の在庫",
  "f_received_qty": "以降の入荷",
  "f_to_group_qty": "以降の他エンティティへの移動",
  "f_sold_qty": "以降の販売",
  "f_other_qty": "その他の移動",
  "f_now_qty": "本日の在庫",
  "f_po_total_qty": "未完了 PO（合計）",
  "f_po_qty": "未完了 PO 数量",
  "f_avg_month_sales": "月平均売上（3か月）",
  "f_months_of_stock": "在庫月数",
  "f_months_with_po": "未完了 PO を含む在庫月数",
  "group_stock": "在庫",
  "f_snapshot": "スナップショット日",
  "f_day_kind": "日の種別（金曜＝週）",
  "f_latest_day": "最新日",
  "f_ageing": "滞留期間",
  "f_stock_kind": "手持ち／輸送中",
  "f_line_status": "行のステータス",
  "f_inbound_year": "入庫年",
  "f_brand": "ブランド",
  "f_goods_type": "商品タイプ",
  "f_inv_category": "カテゴリ",
  "f_inv_subcategory": "サブカテゴリ",
  "f_family": "ファミリー",
  "f_size_class": "サイズ区分",
  "f_consignment": "自社／委託",
  "f_product": "製品",
  "f_color": "カラー",
  "f_stock_amount": "手持ち金額（USD）",
  "f_stock_qty": "手持ち数量",
  "f_transit_amount": "輸送中金額（USD）",
  "f_transit_qty": "輸送中数量",
  "f_over1y_share": "1年超の金額比率 %",
  "f_avg_age": "平均滞留日数",
  "sw_allDays": "取得したすべての日",
  "fieldSearch": "項目を検索…",
  "group_time": "時間",
  "group_product": "製品",
  "group_org": "エンティティとチャネル",
  "group_geo": "地域",
  "group_measures": "値",
  "f_date": "日付",
  "f_line": "ライン",
  "f_category": "製品カテゴリ",
  "f_type": "製品タイプ",
  "f_subtype": "製品サブタイプ",
  "f_frame_model": "フレームモデル",
  "f_frame_color": "フレームカラー",
  "f_sku": "SKU",
  "f_entity_group": "エンティティグループ",
  "f_entity": "エンティティ",
  "f_channel": "チャネル",
  "f_channel2": "サブチャネル",
  "f_channel3": "チャネル詳細",
  "f_customer": "顧客",
  "f_region": "地域",
  "f_subregion": "サブリージョン",
  "f_country": "国",
  "f_revenue": "売上",
  "f_quantity": "数量",
  "f_avg_price": "平均単価",
  "f_sku_count": "SKU 数",
  "f_customer_count": "顧客数",
  "f_lines": "取引明細行",
  "f_target": "目標",
  "f_achievement": "達成率 %",
  "f_vs_target": "目標比",
  "vt_map": "マップ",
  "w_location": "場所",
  "w_mapColor": "色分けの基準",
  "mapNeedsGeo": "マップには、国、サブリージョン、地域のいずれかを配置します。いずれかを「場所」に入れてください。",
  "mapNone": "値なし",
  "mapUnplaced": "マップに表示されないもの（{{n}}）：{{names}}",
  "fmtTopN": "表示",
  "fmtTopN_all": "すべての行",
  "fmtTopN_n": "上位 {{n}} 件",
  "topNote": "最初の値で、{{total}} 件中の上位 {{n}} 件。",
  "topNoteTable": "最初の値で、{{total}} 件中の上位 {{n}} 件。合計行はすべてを集計します。",
  "targetBlocked": "ここでは目標を表示できません。目標は日付、エンティティグループ、エンティティ、チャネルでのみ設定され、{{fields}} では設定されません。",
  "targetBlockedShort": "{{fields}} 別の目標はありません",
  "relWholeN": "完結した期間のみ",
  "relWholeOpt": "期間の終わりまで（目標は期間全体の値）",
  "relWholeNOpt": "完結した期間のみ（現在の期間は除く）",
  "relHintWhole": "期間の開始から終了まで。売上は読み込み済みの最新日で止まり、目標は期間末まで続きます。Sales Report が月初来の実績を月全体の目標と比べるのと同じです。",
  "relHintNWhole": "現在の期間より前の、完結した期間です。「過去5週間」は、今週より前の月曜から日曜までの5週間を指します。",
  "g_year": "年",
  "g_quarter": "四半期",
  "g_month": "月",
  "g_week": "週",
  "g_day": "日",
  "a_sum": "合計",
  "a_avg": "平均",
  "a_min": "最小",
  "a_max": "最大",
  "dropHere": "項目をここにドラッグ",
  "remove": "削除",
  "sw_includeInternal": "社内取引の売上",
  "sw_includeOversea": "海外売上",
  "currency": "通貨",
  "chartTop": "グラフには {{total}} 行中、最初の {{n}} 行を表示しています。",
  "other": "その他",
  "total": "合計",
  "loading": "処理中…",
  "truncated": "上位 {{n}} グループのみ表示しています。残りを見るにはフィルターを追加してください。",
  "tooManyCols": "{{total}} 列中、上位 {{n}} 列を表示しています。他の列を選ぶには、列の項目をフィルターしてください。",
  "moreRows": "さらに {{n}} 行を表示",
  "drillUp": "1つ上のレベルへ",
  "drillInto": "{{value}} をドリルダウン",
  "fInclude": "含める",
  "fExclude": "除外",
  "fContains": "含む",
  "fSearch": "値を検索…",
  "fSelectShown": "表示中をすべて選択",
  "fClear": "クリア",
  "fApply": "適用",
  "fCancel": "キャンセル",
  "fMore": "最初の500件のみ表示しています。他は検索で探してください。",
  "fNone": "一致するものはありません。",
  "fFrom": "開始",
  "fTo": "終了",
  "fAll": "すべての日付",
  "fSelected": "{{n}} 件選択中",
  "containsText": "値に含まれるテキスト",
  "sumIn": "{{field}}：{{values}}",
  "sumNotIn": "{{field}}：{{values}} 以外",
  "sumMore": "さらに {{n}} 件",
  "sumContains": "{{field}} に「{{text}}」を含む",
  "sumRange": "{{field}}：{{from}} – {{to}}",
  "sumFrom": "{{field}}：{{from}}以降",
  "sumTo": "{{field}}：{{to}}まで",
  "sumAll": "{{field}}：すべて",
  "save": "保存",
  "saveAs": "名前を付けて保存…",
  "rename": "名前を変更",
  "share": "共有",
  "delete": "削除",
  "unsaved": "未保存の変更",
  "saved": "保存済み",
  "copyLink": "リンクをコピー",
  "linkCopied": "リンクをコピーしました",
  "by": "{{name}}",
  "confirmDelete": "「{{name}}」を削除しますか？ この操作は元に戻せません。",
  "sharedBadge": "共有中",
  "errLoad": "Data Explorerを読み込めませんでした。",
  "errNoDatasets": "利用できるデータセットがまだありません。管理者にアクセス権を依頼してください。",
  "reports": "レポート",
  "myReports": "自分のレポート",
  "sharedReports": "共有されたレポート",
  "noReports": "保存済みのレポートはまだありません。",
  "newReport": "新規レポート",
  "untitled": "無題のレポート",
  "reportName": "レポート名",
  "editMode": "編集",
  "readMode": "閲覧ビュー",
  "refresh": "データを再読み込み",
  "clearSelection": "選択を解除",
  "emptyVisual": "データペインでフィールドを選択して、このビジュアルを作成してください。",
  "emptyPage": "このページは空です。視覚化ペインで種類を選ぶか、データペインでフィールドにチェックを入れてください。",
  "emptyPageRead": "このページは空です。",
  "tooManyVisuals": "1ページに置けるビジュアルは最大{{n}}個です。",
  "drillMode": "ドリルダウン：クリックすると1階層下に進みます",
  "nextLevel": "次の階層へ",
  "moreOptions": "その他のオプション",
  "showTable": "テーブルで表示",
  "showVisual": "ビジュアルを表示",
  "focus": "フォーカスモード",
  "backToReport": "レポートに戻る",
  "exportData": "データをエクスポート（Excel）",
  "duplicate": "複製",
  "removeVisual": "削除",
  "presets": "期間を選択…",
  "slicerAll": "すべて",
  "dataPane": "データ",
  "visPane": "視覚化",
  "filtersPane": "フィルター",
  "newVisual": "追加",
  "visHint": "種類を選ぶとビジュアルを追加できます。ページ上のビジュアルをクリックすると変更できます。",
  "vt_card": "カード",
  "vt_table": "テーブル",
  "vt_matrix": "マトリックス",
  "vt_column": "縦棒グラフ",
  "vt_stacked": "積み上げ縦棒グラフ",
  "vt_bar": "横棒グラフ",
  "vt_line": "折れ線グラフ",
  "vt_area": "面グラフ",
  "vt_slicer": "スライサー",
  "w_fields": "フィールド",
  "w_columns": "列",
  "w_rows": "行",
  "w_cols": "列",
  "w_values": "値",
  "w_xaxis": "X軸",
  "w_legend": "凡例",
  "w_yaxis": "Y軸",
  "w_yaxisCat": "Y軸",
  "w_xaxisVal": "X軸",
  "w_field": "フィールド",
  "vTitle": "タイトル",
  "grain": "日付の粒度",
  "dateRange": "期間",
  "aggregation": "集計",
  "filtersVisual": "このビジュアルのフィルター",
  "filtersPage": "このページのフィルター",
  "filtersAll": "すべてのページのフィルター",
  "addFilter": "フィルターを追加",
  "pages": "ページ",
  "pageN": "ページ{{n}}",
  "addPage": "新規ページ",
  "pageOptions": "ページのオプション",
  "pageTabHint": "ダブルクリックで名前を変更",
  "renamePage": "ページ名を変更",
  "duplicatePage": "ページを複製",
  "moveLeft": "左へ移動",
  "moveRight": "右へ移動",
  "deletePage": "ページを削除",
  "confirmDeletePage": "ページ「{{name}}」とそのビジュアルを削除しますか？",
  "confirmNewDataset": "別のデータセットを選ぶと新しいレポートが始まります。表示中のレポートは、先に保存しないと失われます。続行しますか？",
  "titleBy": "{{dims}}別 {{values}}",
  "titleAnd": "、",
  "undo": "元に戻す（Ctrl+Z）",
  "redo": "やり直し（Ctrl+Y）",
  "pageDeleted": "ページを削除しました。「元に戻す」で復元できます。",
  "allReports": "すべてのレポート",
  "homeAll": "すべて",
  "homeMine": "自分のレポート",
  "homeShared": "共有されたレポート",
  "homeSearch": "レポートを検索…",
  "colName": "名前",
  "colOwner": "オーナー",
  "colSharedWith": "共有先",
  "colUpdated": "最終更新",
  "you": "自分",
  "sharedWithYou": "あなたに共有",
  "sharedBy": "{{name}}が共有",
  "privateOnly": "非公開",
  "everyone": "全員",
  "everyoneHint": "{{ds}}データを閲覧できる全員",
  "nPeople": "{{n}}人",
  "homeEmptyMine": "レポートはまだありません。「新規レポート」を押して作成してください。",
  "homeEmptyShared": "あなたに共有されたレポートはまだありません。",
  "homeEmptySearch": "該当するレポートがありません。",
  "continueDraft": "前回の続きから再開",
  "draftNew": "未保存の新規レポート",
  "draftChanged": "「{{name}}」の未保存の変更",
  "continue": "続ける",
  "discardDraft": "破棄",
  "confirmDiscard": "「{{name}}」の未保存の変更を破棄しますか？",
  "shareTitle": "「{{name}}」を共有",
  "shareSearch": "ユーザー、部署、エンティティを追加…",
  "kind_all": "全員",
  "kind_team": "部署",
  "kind_entity": "エンティティ",
  "oneTeam": "部署",
  "oneEntity": "エンティティ",
  "kind_user": "ユーザー",
  "sharePrivate": "非公開：自分だけが開けます。",
  "shareReach": "{{n}}人が閲覧できます。",
  "shareCannot": "ここで指定した{{n}}人は、まだ{{ds}}データを閲覧できないため、閲覧できるようになるまでレポートは表示されません：",
  "noAccessTag": "データへのアクセス権なし",
  "noAccessHint": "{{ds}}データの権限がまだないため、権限が付与されるまでレポートは表示されません。",
  "shareNote": "共有された人は閲覧のみで開きます。フィルターやスライサーは本人の画面にだけ反映されます。レポートを変更できるのはあなただけで、レポートを作成できる人は誰でもコピーを保存できます。",
  "makePrivate": "非公開にする",
  "shareSaved": "共有設定を保存しました",
  "shareSaveFirst": "先にレポートを保存してから共有してください。",
  "removeShare": "削除",
  "peopleWithAccess": "アクセスできるユーザー",
  "generalAccess": "一般アクセス",
  "youMark": "（自分）",
  "roleOwner": "オーナー",
  "roleViewer": "閲覧者",
  "roleEditor": "編集者",
  "roleHead": "役割",
  "transferOwnership": "オーナーを移譲",
  "transferNoBuild": "{{name}}はレポートを作成できない（Data Explorerへのアクセス権なし）ため、オーナーになれません。",
  "transferNoData": "{{name}}はまだ{{ds}}データを閲覧できません。",
  "transferAsk": "{{name}}をオーナーにしますか？",
  "transferHint": "あなたは編集者として残ります。共有、削除、オーナーの移譲ができるのは新しいオーナーだけです。",
  "transferGo": "移譲",
  "transferDone": "{{name}}がレポートのオーナーになりました。あなたは編集者として残ります。",
  "roleOf": "アクセス権",
  "removeAccess": "アクセス権を削除",
  "genRestricted": "制限付き",
  "genRestrictedHint": "上で追加したユーザーだけがリンクから開けます",
  "genEveryone": "{{ds}}データを閲覧できる全員",
  "genEveryoneHint": "{{ds}}データを閲覧できるHelinoxの全員が、閲覧のために開けます",
  "shareDone": "完了",
  "noMatch": "該当するものがありません。",
  "notFound": "このレポートは存在しないか、あなたに共有されていません。",
  "deleted": "レポートを削除しました",
  "fBackwards": "終了日が開始日より前になっています。",
  "nPerson": "1人",
  "shareReachOne": "1人が閲覧できます。",
  "rel_today": "今日",
  "rel_yesterday": "昨日",
  "rel_thisWeek": "今週",
  "rel_lastWeek": "先週",
  "rel_thisMonth": "今月（本日まで）",
  "rel_lastMonth": "先月",
  "rel_thisQuarter": "今四半期（本日まで）",
  "rel_lastQuarter": "前四半期",
  "rel_thisYear": "今年（本日まで）",
  "relW_thisWeek": "今週（全体）",
  "relW_thisMonth": "今月（全体）",
  "relW_thisQuarter": "今四半期（全体）",
  "relW_thisYear": "今年（全体）",
  "rel_lastYear": "昨年",
  "relLastN_day": "過去{{n}}日間",
  "relLastN_week": "過去{{n}}週間",
  "relLastN_month": "過去{{n}}か月",
  "relLastN_year": "過去{{n}}年間",
  "relLast": "過去",
  "relLastN": "数",
  "relUnit": "単位",
  "relUnit_day": "日",
  "relUnit_week": "週",
  "relUnit_month": "か月",
  "relUnit_year": "年",
  "relHint": "日付ではなく期間として保存されます。「今月」で保存したレポートは、開くたびにその時点の今月を表示します。「今…」は本日までです。",
  "relHintN": "本日を含め、今日から遡って数えます。月と年は暦どおりの1か月・1年単位です。「過去12か月」は今月とその前の11か月です。",
  "relBadN": "1～400の整数を入力してください。",
  "fMode_relative": "相対期間",
  "fMode_range": "日付を指定",
  "fClearDates": "日付をクリア",
  "sumRel": "{{field}}：{{period}}",
  "vt_kpi": "KPI",
  "vt_combo": "折れ線と縦棒",
  "vt_pie": "円",
  "vt_donut": "ドーナツ",
  "w_indicator": "値",
  "w_trend": "トレンド軸",
  "w_colValues": "縦棒の値",
  "w_lineValues": "折れ線の値",
  "showAs": "値の表示形式",
  "calc_none": "値",
  "calc_py": "前年同期",
  "calc_yoy": "前年比の増減",
  "calc_yoy_pct": "前年比の増減 %",
  "calc_pm": "前月の同じ日数",
  "calc_mom": "前月比の増減",
  "calc_mom_pct": "前月比の増減 %",
  "calc_share": "合計に対する %",
  "kpiTitle": "{{value}}（前年比）",
  "kpiNoLy": "前年の同じ日数の数値がありません",
  "kpiVsLy": "前年 {{value}} 比",
  "pieNegatives": "マイナスの値は円グラフに含まれません。",
  "expandAll": "すべて展開",
  "collapseAll": "すべて折りたたむ",
  "expand": "展開",
  "collapse": "折りたたむ",
  "tab_build": "作成",
  "tab_format": "書式",
  "fmtShowTitle": "タイトルを表示",
  "fmtNumbers": "数値",
  "fmtUnits": "表示単位",
  "fmtUnits_default": "フィールドに従う",
  "fmtUnits_auto": "自動（1.2M）",
  "fmtUnits_none": "なし",
  "fmtUnits_K": "千（K）",
  "fmtUnits_M": "百万（M）",
  "fmtUnits_B": "十億（B）",
  "fmtDecimals": "小数点以下の桁数",
  "fmtAuto": "自動",
  "fmtChart": "グラフ",
  "fmtLabels": "データラベル",
  "anchored": "期間の基準日：{{date}}",
  "anchoredHint": "このページまたはレポートで選んだ期間は{{date}}で終わるため、各ビジュアルの「今年」「先週」「今月」などは、今日ではなくその日を基準に計算されます。",
  "colAction": "操作",
  "open": "開く",
  "slicerPicked": "{{n}}件選択中",
  "fmtSlicerStyle": "スタイル",
  "fmtSlicer_list": "リスト",
  "fmtSlicer_dropdown": "ドロップダウン",
  "renameValue": "このビジュアルでの名前を変更",
  "renamedFrom": "{{name}} — このビジュアルで{{field}}から名前を変更",
  "fmtLegend": "凡例",
  "fmtLegend_top": "上",
  "fmtLegend_bottom": "下",
  "fmtLegend_right": "右",
  "fmtLegend_none": "非表示",
  "fmtColour": "色",
  "fmtCond": "条件付き書式",
  "fmtCondKind": "セル",
  "fmtCond_none": "なし",
  "fmtCond_scale": "カラースケール",
  "fmtCond_bars": "データバー",
  "fmtCondHint_scale": "各セルは値の大きさに応じて色が付き、大きいほど濃くなります。マイナスの値は赤で表示されます。合計は色が付きません。",
  "fmtCondHint_bars": "各セルに、表内の最大値に対する割合の長さのバーが付きます。合計にはバーが付きません。",
  "fmtReset": "既定の書式に戻す"
};

const dictionary = { ns: 'xExplorer', en, ko, vi, zh, fr, ja };

export default dictionary;
